<!-- 第三版销售单编辑 -->
<template>
    <div class="saleorder-v3" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div class="bread-nav">
            <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showSearch()" tabindex="-1">搜索配件(F2)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1">查看配件信息(F3)</el-button>
            <el-button class="search-btn btn-primary" title="报价历史" size="small" @click.stop="showHistories()" v-if="permission.quoteHistory">报价历史(F4) </el-button>
            <el-button title="销售历史" size="small" @click.stop="showHistoryDialog()" class="search-btn btn-primary" v-if="permission.salesHistory"
                >销售历史(F5)
            </el-button>
            <el-button title="采购历史" size="small" @click.stop="showPurHistories()" class="search-btn btn-primary" v-if="permission.purHistory"
                >采购历史(F6)
            </el-button>
            <el-button size="small" class="search-btn btn-primary" @click="lceHandle(1)" v-if="!dataReadonly && permission.AddLogistics"
                >{{ permission.AddLogistics }} (F7)</el-button
            >
            <el-button size="small" class="search-btn btn-primary" @click="lceHandle(2)" v-if="this.submitData.LogisticId && !dataReadonly && permission.EditLogistics"
                >{{ permission.EditLogistics }} (F8)</el-button
            >
            <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="!dataReadonly && permission.addCustomer && type != 8 && type != 4"
                >{{ permission.addCustomer }} (F9)</el-button
            >
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click="addCustomer(2)"
                v-if="!dataReadonly && permission.editCustomer && submitData.EntpCusId && type != 8 && type != 4"
                >{{ permission.editCustomer }} (F10)
            </el-button>
            <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click.stop="showAddAPDialog" v-if="permission.addGoods">新增配件商品</el-button>
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click.stop="submitForm(type, 0)"
                v-if="permission.save && type != 8"
                :disabled="saving || (isForbid && isPaySpecial)"
                >{{ permission.save }}(F11)</el-button
            >
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click.stop="submitForm(type, 1)"
                v-if="permission.submit"
                :disabled="saving || (isForbid && isPaySpecial)"
                >{{ permission.submit }}(F12)</el-button
            >
        </div>
        <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'">
            <div>
                <span>订单信息{{ submitData.OrderCode ? '【' + submitData.OrderCode + '】' : '' }}</span>
                <span v-if="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;客户：{{ submitData.EntpCusName }}</span>
                <span style="margin-left: 10px; font-weight: 500">
                    【 商品总数：{{ allNum }} &nbsp;&nbsp; 销售总额：{{ allMoney }} 】
                    <span style="color: red"
                        >{{
                            creditDay != 0 && isCheckCredit && ownMoney != 0
                                ? creditType == 0
                                    ? '【 结算周期：' + creditDay + ' 天】'
                                    : '【 固定每月 ' + creditDay + ' 号结算】'
                                : ''
                        }}{{ maxCreditMoney == 0 ? '' : '【 最高挂账额度：' + maxCreditMoney.toFixed(2) + ' 】' }}</span
                    >
                    <span
                        v-if="!permission.checkOwnDetails"
                        :style="maxCreditMoney == 0 ? 'color: red' : maxCreditMoney != 0 && maxCreditMoney <= ownMoney ? 'color: red' : ''"
                    >
                        {{ ownMoney == 0 ? '' : ' 已欠：' + ownMoney.toFixed(2) }}
                    </span>
                    <el-button v-else type="text" @click="showOwnDialog()" class="btn-own"> {{ ownMoney == 0 ? '' : ' 已欠：' + ownMoney.toFixed(2) }}</el-button>
                </span>
                <span v-if="type == 3" style="font-size: 14px; margin-left: 10px; color: red"> （ 温馨提醒：重新开单只会生成新的销售订单，将不影响旧的销售订单 ） </span>
                <span v-if="submitData.WarehouseName" class="wNameTip"
                    >出仓仓库：<i>{{ submitData.WarehouseName }}</i></span
                >
            </div>
            <div class="img-e-op" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/down-e.png" />
            </div>
            <div class="img-e-op" @click="hideMsg" v-show="showOrderMsg">
                <img src="../../../assets/images/up-e.png" />
            </div>
        </div>
        <div class="order-infoes" v-show="showOrderMsg">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="选择客户" prop="EntpCusId">
                                <el-input v-if="type == 4" disabled size="small" v-model.trim="submitData.EntpCusName"> </el-input>
                                <el-select
                                    ref="cusselect"
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly || type == 8"
                                    v-model="submitData.EntpCusId"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchCustomLoad"
                                    @change="customerChange($event)"
                                    @visible-change="customerVisibleChange($event)"
                                    placeholder="输入客户名称/电话"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :data-msg="optionItem"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    >
                                        <span style="float: left">{{ optionItem.EntpCusName }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                                    </el-option>
                                    <el-option v-if="cusLoading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="业务员" prop="SId">
                                <el-select
                                    v-model="submitData.SId"
                                    :disabled="dataReadonly"
                                    filterable
                                    clearable
                                    placeholder="请选择"
                                    @change="sIdChange($event)"
                                    @visible-change="siVisibleChange($event)"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="联系电话" prop="PhoneNum">
                                <el-input :disabled="dataReadonly || !yxbPermission" v-model.trim="submitData.PhoneNum" size="small"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipType">
                                <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                    <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <el-form-item label="运输费用" prop="ShipAmount">
                                <el-input
                                    min="0"
                                    type="number"
                                    step="0.01"
                                    :disabled="dataReadonly || !yxbPermission"
                                    v-model.trim="submitData.ShipAmount"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="支付方式" prop="PayType">
                                <el-select
                                    v-model="submitData.PayType"
                                    @change="payChange($event)"
                                    :disabled="dataReadonly || !yxbPermission"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="出仓仓库" prop="WarehouseId">
                                <el-input
                                    v-if="
                                        dataReadonly ||
                                        ((submitData.IsPartialOutWarehouse || submitData.IsDelivery) && warehouseList.length == 1) ||
                                        submitData.IsERPOrder
                                    "
                                    :title="submitData.WarehouseName"
                                    v-model="submitData.WarehouseName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    v-model="submitData.WarehouseId"
                                    :disabled="dataReadonly"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    size="small"
                                    filterable
                                    clearable
                                    @visible-change="warehouseVisibleChange($event)"
                                    @change="warehouseChange"
                                >
                                    <el-option
                                        v-for="optionItem in warehouseList"
                                        :key="optionItem.WarehouseId"
                                        :label="optionItem.WarehouseName"
                                        :value="optionItem.WarehouseId"
                                    >
                                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="跟单采购员" prop="FollowerId">
                                <el-select
                                    v-model="submitData.FollowerId"
                                    :disabled="dataReadonly"
                                    filterable
                                    clearable
                                    placeholder="请选择"
                                    @change="followerChange($event)"
                                    @visible-change="siVisibleChange($event)"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="(item, index) in FollowerList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流公司" prop>
                                <el-input
                                    v-if="dataReadonly"
                                    :title="submitData.LogisticName"
                                    v-model="submitData.LogisticName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    size="small"
                                    v-model="submitData.LogisticItem"
                                    placeholder="请输入物流公司"
                                    value-key="EntpCusId"
                                    filterable
                                    clearable
                                    default-first-option
                                    remote
                                    reserve-keyword
                                    v-select-scroll-more="searchLogisLoad"
                                    :remote-method="searchLogistic"
                                    @visible-change="logisticVisibleChange($event)"
                                    @change="logisticChange"
                                >
                                    <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item">
                                        <div class="name">
                                            {{ item.EntpCusName }}
                                            <span class="phone" v-if="item.Phone">
                                                {{ ' ( 电话：' + item.Phone + ' )' }}
                                            </span>
                                        </div>
                                    </el-option>
                                    <el-option key="_load" v-if="logisLoading" disabled value style="text-align: center">
                                        加载中 <i class="el-icon-loading"></i>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                <el-input :disabled="dataReadonly" size="small" v-model.trim="submitData.LogisticsOrderNo" :max="30"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-autocomplete
                                    :disabled="dataReadonly || !yxbPermission"
                                    v-model.trim="submitData.FullAddress"
                                    style="width: 100%"
                                    size="small"
                                    :fetch-suggestions="querySearch"
                                ></el-autocomplete>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div class="customer-view">
                            <el-form-item label="客人要求" class="grid-content bg-purple">
                                <el-tooltip :content="submitData.Remark" placement="top" effect="light" v-if="submitData.Remark && dataReadonly">
                                    <el-input :disabled="dataReadonly" v-model="submitData.Remark" size="small"> </el-input>
                                </el-tooltip>
                                <el-input v-else :disabled="dataReadonly" v-model="submitData.Remark" size="small"> </el-input>
                            </el-form-item>
                            <div class="customer-checked" v-if="isEdit">
                                <el-checkbox v-model="customerChecked">提交后是否展示到下次订单中？</el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5" v-if="isUseSource">
                        <div class="grid-content bg-purple">
                            <el-form-item label="订单来源" prop="CusSources">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.CusSourcesName"></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly"
                                    v-model="submitData.CusSources"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="sourceChange($event)"
                                    @visible-change="sourceVisibleChange($event)"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="optionItem in cusSourcesList"
                                        :key="optionItem.Value"
                                        :data-msg="optionItem"
                                        :label="optionItem.Text"
                                        :value="optionItem.Value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="isOrgShow">
                        <div class="grid-content bg-purple">
                            <el-form-item label="部门" prop="OrgId">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.OrgName"></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="dataReadonly"
                                    v-model="submitData.OrgId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="orgChange($event)"
                                    @visible-change="orgVisibleChange($event)"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="optionItem in orgList"
                                        :key="optionItem.Id"
                                        :data-msg="optionItem"
                                        :label="optionItem.Name"
                                        :value="optionItem.Id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="7" style="width: auto">
                        <div class="discount-zone">
                            <div>
                                <el-select
                                    v-model="submitData.DiscountType"
                                    :disabled="dataReadonly || hasPaid || !yxbPermission"
                                    placeholder="请选择"
                                    size="small"
                                    style="width: 120px"
                                >
                                    <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <el-input-number
                                v-if="submitData.DiscountType === 1"
                                size="small"
                                :disabled="dataReadonly || hasPaid || !yxbPermission"
                                v-model="submitData.DiscountAmount"
                                :min="0"
                                :step="0.01"
                                :precision="2"
                                controls-position="right"
                                :max="Number(allMoney)"
                                style="width: 134px"
                            >
                            </el-input-number>
                            <div class="percent-view" v-else-if="submitData.DiscountType === 2">
                                <el-input-number
                                    size="small"
                                    placeholder="请输入"
                                    :controls="false"
                                    :min="0"
                                    :max="100"
                                    :precision="2"
                                    :disabled="dataReadonly || hasPaid || !yxbPermission"
                                    v-model="submitData.DiscountRate"
                                ></el-input-number>
                                <span>%</span>
                            </div>
                            <div>
                                <span style="margin: 0 12px" v-if="!noFee">=</span>
                                实收金额：
                                <span class="discount-count">￥ {{ discountCount }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="customer-view" v-if="autoSeriesModel && autoSeriesModel.VIN">
                            <el-tag closable @click="vinSearch" @close="closeAutoSeries">{{ autoSeriesModel && autoSeriesModel.VIN ? autoSeriesModel.VIN : '' }}</el-tag>
                            <div class="customer-checked">
                                <el-checkbox v-model="isLockVIN">是否绑定配件与车型数据</el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg">
            <div>
                <span>搜索配件结果</span>
                <span style="margin-left: 10px; font-size: 14px"
                    >{{
                        tableDataLength > 0
                            ? '(' +
                              (autoSeriesModel && autoSeriesModel.VIN && autoSeriesModel.AutoSeriesId && isUseAS
                                  ? 'VIN：' + autoSeriesModel.VIN + ' 精准匹配'
                                  : autoSeriesModel && autoSeriesModel.VIN && !autoSeriesModel.AutoSeriesId
                                    ? '车型：' + autoSeriesModel.ModelName + ' 匹配'
                                    : '') +
                              '结果数：' +
                              tableDataLength +
                              ')'
                            : ''
                    }}
                </span>
                <el-link style="width: 120px" v-show="tableDataLength > 0" type="primary" @click="chooseAllAPsHandle">全部加入订单明细</el-link>
            </div>
            <div class="flex">
                <el-button icon="el-icon-refresh" type="primary" class="search-set-btn" @click="refreshResult()"></el-button>
                <el-button v-if="isCanTBSet" icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                    <img src="../../../assets/images/down-e.png" />
                </div>
                <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                    <img src="../../../assets/images/up-e.png" />
                </div>
            </div>
        </div>
        <!--  -->
        <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" style="margin-bottom: 5px">
            <ux-grid
                ref="multipleTable"
                height="336px"
                style="width: 100%"
                highlight-current-row
                @cell-dblclick="dblChooseAps"
                @table-body-scroll="tableLoad"
                v-loading="searchData.page == 1 ? searchLoading : false"
                show-overflow
                :data="tableData"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                empty-text=""
                @sort-change="sortChange"
                @row-contextmenu="handleRowContextmenu"
            >
                <template v-for="(col, index) in columnShowSets">
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'APCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.MainImage" style="padding: 0" icon="el-icon-picture" type="text"></el-button>
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }}</i>
                            <i v-else>{{ scope.row.APCode }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'GoodCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodCode }}</i>
                            <i v-else>{{ scope.row.GoodCode }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'GoodName'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodName }}</i>
                            <i v-else>{{ scope.row.GoodName }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'AutoSerise'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-tooltip placement="top">
                                <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.AutoSerise)"></div>
                                <div class="tooltip-div">
                                    <el-tag
                                        v-if="row.SeriesCount > 0 || row.IsCommonSeries"
                                        @click="showSeries(row)"
                                        type="danger"
                                        effect="plain"
                                        size="small"
                                        style="padding: 0 2px; margin-right: 2px"
                                        >{{ row.IsCommonSeries ? '通用' : row.SeriesCount }}</el-tag
                                    >{{ row.AutoSerise }}
                                </div>
                            </el-tooltip>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'MarketPrice'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            {{
                                priceType == 0
                                    ? row.MarketPrice
                                    : priceType == 1
                                      ? calcType == 1
                                          ? Math.round(row.CostPrice * pricePoint)
                                          : calcType == 2
                                            ? Math.ceil(row.CostPrice * pricePoint)
                                            : calcType == 3
                                              ? Math.floor(row.CostPrice * pricePoint)
                                              : (row.CostPrice * pricePoint).toFixed(2)
                                      : priceType == 2
                                        ? calcType == 1
                                            ? Math.round(row.Price * pricePoint)
                                            : calcType == 2
                                              ? Math.ceil(row.Price * pricePoint)
                                              : calcType == 3
                                                ? Math.floor(row.Price * pricePoint)
                                                : (row.Price * pricePoint).toFixed(2)
                                        : priceType == 3
                                          ? calcType == 1
                                              ? Math.round(row.MarketPrice * pricePoint)
                                              : calcType == 2
                                                ? Math.ceil(row.MarketPrice * pricePoint)
                                                : calcType == 3
                                                  ? Math.floor(row.MarketPrice * pricePoint)
                                                  : (row.MarketPrice * pricePoint).toFixed(2)
                                          : row.MarketPrice
                            }}
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'Inventory'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <span class="inven-active">{{ submitData.WarehouseId ? row.StorageInventory : row.Inventory }}</span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'Remaining'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <span class="out-active">
                                {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'OrderWaitOutQuantity'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                    row.OrderWaitOutQuantity
                                }}</el-button>
                                <span v-else>{{ row.OrderWaitOutQuantity }}</span>
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'POrderWaitInQuantity'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                    row.POrderWaitInQuantity
                                }}</el-button>
                                <span v-else>{{ row.POrderWaitInQuantity }}</span></span
                            >
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'PlanPurchase'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showPurPlanData(row)" type="text" style="padding: 0px" v-if="row.PlanPurchase > 0">{{ row.PlanPurchase }}</el-button>
                                <span v-else>{{ row.PlanPurchase }}</span>
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        v-else-if="col.ColumnCode == 'IntenCount'"
                        show-overflow-tooltip
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button v-if="row.IntenCount > 0" @click="showIntentDatas(row.EntpTempGoodsId)" type="text" style="padding: 0px">{{
                                    row.IntenCount
                                }}</el-button>
                                <span v-else>{{ row.IntenCount }}</span></span
                            >
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="col.ColumnCode + index"
                        :field="col.ColumnCode"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :title="col.ColumnName"
                        resizable
                        :sortable="col.IsSort"
                        :remote-sort="col.IsSort"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </ux-table-column>
                </template>
            </ux-grid>
            <div class="invens-summary" v-if="isShowSummary">
                <span class="title">各仓库库存数据：</span>
                <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                    <span class="sname">【 {{ item.Name }} 】</span>
                    <span class="sname">库存数：</span>
                    <span class="scount"> {{ item.Count }} </span>
                </div>
            </div>
        </div>
        <!--    table    -->
        <div class="section-title" @click="hideMsg()">
            <div>
                订单商品明细
                <span v-if="type == 8 && (submitData.IsPartialOutWarehouse || submitData.IsDelivery)" style="font-size: 14px; margin-left: 10px; color: red">
                    （ 温馨提醒：已出仓的商品不能再进行修改！部分出仓的商品数量可修改，但不能少于已出仓数！ ）
                </span>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" @click="hideMsg()" class="sales-order-edit">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="odetailH"
                :highlight-current-row="false"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                row-id="rowkey"
                @edit-closed="editClosed"
                empty-text="暂无销售商品明细"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <span class="sp-i" v-show="row.APCode">
                                <i title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <!-- .native 修饰符就是用来注册元素的原生事件而不是组件自定义事件的 -->
                    <!-- 用第三方组件或者UI框架会自带自身封装的事件，如keyup等，会覆盖原生的组件而无法起效果 -->
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            ref="sapcode"
                            :disabled="dataReadonly || scope.row.hasLock || scope.row.WarehousedCount > 0 || !yxbPermission"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                            @blur.stop="blurCode($event, scope.row)"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">
                                        {{ optionItem.GoodCode }}
                                    </div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            ref="partsNameSelect"
                            v-model="scope.row.GoodName"
                            :disabled="scope.row.hasLock"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            @focus="selectAutoHandle('partsNameSelect')"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            :disabled="scope.row.hasLock"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            @focus="selectAutoHandle('autoSeriseSelect')"
                            ref="autoSeriseSelect"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="150" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly || !yxbPermission"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="160" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <!--autofocus，如果是自定义渲染可以指定聚焦的选择器，他的作用很明显就是你点击一下就帮你去获取焦点。
                你无需点击第二次再去获取焦点。autofocus的值就是你编辑型输入框（edit）组件的类名-->
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('countRef')">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="salecounts-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="type != 7 ? (scope.row.WarehousedCount > 0 ? scope.row.WarehousedCount : 1) : 1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                                :disabled="dataReadonly || (type == 8 && scope.row.IsDelivery) || !yxbPermission"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">
                            {{ row.Unit }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            :disabled="dataReadonly || (type == 4 && !scope.row.canEdit) || (type == 8 && scope.row.WarehousedCount > 0) || !yxbPermission"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            @keyup.right.native="keyEvent($event, 'Unit')"
                            @keyup.left.native="keyEvent($event, 'Unit')"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="MarketPrice" title="销售价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格；
                                <br />若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">
                                利润率：{{ row.MarketPrice != 0 && row.CostPrice != 0 ? (((row.MarketPrice - row.CostPrice) / row.CostPrice) * 100).toFixed(2) : 0 }}%
                            </div>
                            <div
                                :class="[
                                    'div-padding-12',
                                    {
                                        'special-border': CheckLoseMoney(row.CostPrice, row.MarketPrice) || !row.MarketPrice
                                    }
                                ]"
                            >
                                <span
                                    :class="{
                                        'color-red': row.MarketPrice === 0 || row.MarketPrice < row.CostPrice
                                    }"
                                    >{{ row.MarketPrice }}</span
                                >
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <div
                            class="sales-input-cell"
                            v-if="(LoseMoneyValue && !dataReadonly && !(scope.row.WarehousedCount > 0)) || priceCanBeEdit"
                            :class="{
                                loseMoneyWarning: CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)
                            }"
                        >
                            <el-tooltip :disabled="!CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)" effect="light" placement="right">
                                <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                <el-input-number
                                    ref="marketPirceRef"
                                    size="small"
                                    :precision="2"
                                    :step="0.1"
                                    controls-position="right"
                                    v-model="scope.row.MarketPrice"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @change="priceCheck(scope.row)"
                                    @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                    @keyup.right.native="keyEvent($event, 'MarketPrice')"
                                    @focus="selectAutoHandle('marketPirceRef')"
                                    :disabled="!yxbPermission"
                                >
                                </el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || scope.row.WarehousedCount > 0 || !priceCanBeEdit || !yxbPermission"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.MarketPrice"
                                placeholder="销售价"
                                @input="priceChange"
                                @change="priceCheck(scope.row)"
                                @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                @keyup.right.native="keyEvent($event, 'MarketPrice')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column
                    field="BillingPrice"
                    title="开单价"
                    width="120"
                    v-if="isBPriceShow"
                    :edit-render="{ autofocus: '.el-input__inner' }"
                    resizable
                    key="BillingPrice"
                >
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.BillingPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                ref="billingPriceRef"
                                size="small"
                                :precision="2"
                                :step="0.1"
                                controls-position="right"
                                v-model="scope.row.BillingPrice"
                                placeholder="开单价"
                                @keyup.left.native="keyEvent($event, 'BillingPrice')"
                                @focus="selectAutoHandle('billingPriceRef')"
                                :disabled="dataReadonly"
                            >
                            </el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="xszj" title="销售总价" width="120" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ ((row.MarketPrice ? row.MarketPrice : 0) * (row.Count ? row.Count : 0)).toFixed(2) }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="IsUrgent" v-if="isUrgentShow" title="急件" width="55" resizable key="IsUrgent">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-checkbox
                                v-model="row.IsUrgent"
                                @change="urgentchange(row)"
                                :disabled="dataReadonly || (row.WarehousedCount > 0 && !row.IsUrgent) || isPay || row.IsPur"
                                style="margin-left: 10px"
                            ></el-checkbox>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type !== 6" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex, row)"
                                icon="el-icon-delete"
                                :tabindex="-1"
                                v-if="
                                    yxbPermission &&
                                    dataList.length !== 1 &&
                                    (type == 8 ? row.WarehousedCount == 0 : !dataReadonly && (type == 0 || type == 2 || type == 3 || type == 4 || type == 9))
                                "
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="
                                    rowIndex + 1 === dataList.length && !dataReadonly && (type == 0 || type == 4 || type == 2 || type == 3 || type == 8 || type == 9) && yxbPermission
                                "
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   新增客户    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑客户' : '新增客户'" :visible.sync="dialogCusVisible" width="1000px">
            <div class="dialog-content" v-if="dialogCusVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="1" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="goodsId"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyPurVisible" width="1200px">
            <div v-if="historyPurVisible">
                <APPurchaseHistory :EntpTempGoodsId="goodsId" :Source="1" @closeDialog="closeHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="goodsId"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APQuoteHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件在订数据"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="1"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="purPlanTitle"
            :close-on-click-modal="false"
            :visible.sync="purPlanDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="purPlanDataVisible">
                <APPurPlanDatas ref="APPurPlanDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="purPlanDataVisible = false"></APPurPlanDatas>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="apMsgVisible" width="1000px">
            <div v-if="apMsgVisible">
                <APMsg :dialogFormVisible="apMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="apAutoMsgVisible" width="1380px">
            <div v-if="apAutoMsgVisible">
                <APAutoMsg :dialogFormVisible="apAutoMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APAutoMsg>
            </div>
        </el-dialog>
        <!--  打印  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" title="打印" :visible.sync="isShowPrintCHDlg" width="870px">
            <div class="dialog-content" v-if="isShowPrintCHDlg">
                <printContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1" :showDisc="showDisc" :isInit="true"></printContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printContent ref="printDom" @closeDialog="closePrintDialog" :printIds="idList" :showDisc="showDisc" :isInit="false"></printContent>
        </div>
        <!--  打印英文版  -->
        <el-dialog
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="打印英文销售单"
            :visible.sync="isShowPrintEngDlg"
            width="870px"
        >
            <div class="dialog-content" v-if="isShowPrintEngDlg">
                <printEngContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"> </printEngContent>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogPrint" :close-on-click-modal="false" width="540px">
            <div style="width: 100%; height: 100%; text-align: center; margin: 25px 0px 25px 0px">
                <span v-if="warehouseType == 0 || isPrintWH2" style="font-size: 16px">
                    <i class="el-icon-info" style="color: #67c23a"></i>请选择提交或打印的相关选项
                </span>
                <span style="font-size: 16px" v-else> <i class="el-icon-info" style="color: #67c23a"></i>是否确认提交？ </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" class="btnSupMini" @click="printAndSubmit(0)" :disabled="saving">仅提交(F1)</el-button>
                <el-button
                    size="mini"
                    class="btnSupMini"
                    type="primary"
                    @click="printAndSubmit(1)"
                    v-if="(warehouseType == 0 || isPrintWH2) && (permission.print || permission.printPreview)"
                    :disabled="saving"
                    >提交并打印(F2)</el-button
                >
                <el-button
                    size="mini"
                    class="btnSupMini"
                    type="primary"
                    @click="printAndSubmit(3)"
                    v-if="(warehouseType == 0 || isPrintWH2) && isAutoPrint && (permission.print || permission.printPreview)"
                    :disabled="saving"
                    >提交并自动打印(F3)</el-button
                >
                <el-button size="mini" class="btnSupMini" type="primary" @click="printAndSubmit(2)" :disabled="saving" v-if="permission.printEng"
                    >提交，打印英文版(F4)</el-button
                >
                <el-button size="mini" class="btnSupMini" @click="canclePrint" :disabled="saving">取消(Esc)</el-button>
            </span>
        </el-dialog>
        <!-- 新增和编辑物流公司 -->
        <el-dialog :close-on-click-modal="false" :title="lceParams.title" :visible.sync="lceParams.visible" width="1000px">
            <div class="dialog-content" v-if="lceParams.visible">
                <logisticsCompanyEdit ref="logisticsCompanyEdit" :compId="lceParams.id" :type="lceParams.type" @closeDialog="closeLceDialog"></logisticsCompanyEdit>
            </div>
        </el-dialog>
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件搜索"
            :visible.sync="searchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-dc-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
            @close="closeSearchDialog"
        >
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码" v-if="isExObj_APCode">
                        <el-autocomplete
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCode"
                            :fetch-suggestions="searchAPCode"
                            :debounce="500"
                            placeholder="请输入配件编码"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAPCodeLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="配件名称" v-if="isExObj_GoodName">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入配件名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型" v-if="isExObj_AutoSerise">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            :popper-append-to-body="false"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="精准车型" v-if="autoSeriesModel">
                        <el-tag closable style="width: 233px" @close="closeAutoSeries">
                            {{ autoSeriesModel.AutoSeries }}
                        </el-tag>
                        <el-checkbox v-model="isUseAS" style="margin-left: 10px"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="互换码" v-if="isExObj_GoodCode">
                        <el-input
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodCode"
                            placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类" v-if="isExObj_Cate">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌" v-if="isExObj_Brand">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数" v-if="isExObj_Inventory">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_7"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_7')"
                            ></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent2"
                                v-if="searchData.Symbol == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="尺寸" v-if="isExObj_Size">
                        <el-input
                            ref="search_8"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Size"
                            placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="产地" v-if="isExObj_Origin">
                        <el-autocomplete
                            ref="search_9"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Origin"
                            :fetch-suggestions="searchOrigin"
                            :debounce="500"
                            placeholder="请输入产地信息"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchOriginLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="自定义属性" v-if="isExObj_GoodDesc">
                        <el-input
                            ref="search_10"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodDesc"
                            placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button v-if="permission.VINSearch" size="small" type="primary" class="search-btn" @click="vinSearch">{{ permission.VINSearch }} (F4)</el-button>
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            width="400px"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="参考价格">
                        <el-input v-model="rowForm._referencePrice" disabled size="small" style="width: 90%" />
                        <el-tooltip :content="referPrice" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input
                            :min="1"
                            @input="change($event)"
                            ref="confirm_0"
                            key="confirm_0"
                            v-model="rowForm._count"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input
                            :min="0"
                            @input="change($event, 1)"
                            ref="confirm_1"
                            v-model="rowForm._price"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="开单价" v-if="isBPriceShow">
                        <el-input
                            :min="0"
                            @input="change($event, 2)"
                            ref="confirm_2"
                            v-model="rowForm._biilPrice"
                            size="small"
                            @focus="selectAutoHandle('confirm_2')"
                            style="width: 100%"
                            type="number"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" :disabled="rowFormLoading" @click="rowConfirm">加入清单(Enter)</el-button>
                <el-button size="small" @click="rowClose" :disabled="rowFormLoading">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="主图"
            width="150px"
            :visible.sync="imageVisible"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px" v-if="imageVisible && currentRow.MainImage">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="downloadUrl + currentRow.MainImage + '?imageView2/2/w/100'"
                    @click="getGoodsImages()"
                    fit="contain"
                    lazy
                ></el-image>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="欠款数据" :visible.sync="isShowOwn" append-to-body width="1000px">
            <div class="dialog-content" v-if="isShowOwn">
                <OwnDetails ref="ownDetails" @closeOwnDetails="closeOwnDetails" :EntpCusId="submitData.EntpCusId" :EntpCusName="submitData.EntpCusName"></OwnDetails>
            </div>
        </el-dialog>
        <el-dialog
            title="VIN快搜"
            :close-on-click-modal="false"
            :visible.sync="vinSearchVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="vin-search-dialog"
            style="margin-left: -500px"
            width="1000px"
        >
            <div class="dialog-content" v-if="vinSearchVisible">
                <vinSearch ref="vinSearch" :VIN="autoSeriesModel && autoSeriesModel.VIN ? autoSeriesModel.VIN : ''" Source="1" @closeDialog="closeVinSearch"></vinSearch>
            </div>
        </el-dialog>
        <!--    绑定的车型数据    -->
        <el-dialog title="绑定的车型数据" :close-on-click-modal="false" :visible.sync="seriesVisible" width="1200px">
            <div class="dialog-content" v-if="seriesVisible">
                <bindSeries ref="bindSeries" :GoodsId="goodsId" :IsShowOpBtn="permission.removeBind ? true : false" />
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 鼠标右键菜单 -->
        <contextMenu v-if="menuVisible" @menuListen="menuListen" ref="contextbutton" @handleMenu="handleMenu" :menuList="menuList"></contextMenu>
        <!--    增加采购单    -->
        <el-dialog title="增加采购单" :close-on-click-modal="false" :visible.sync="aToPurOrderVisible" :before-close="aToPurOrderBeforeClose" width="1200px">
            <div class="dialog-content" v-if="aToPurOrderVisible">
                <addGoodsToPurOrder ref="addGoodsToPurOrder" :GoodsData="currentRow" @closeDialog="closeAddToPurOrder" />
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="挂账限制提醒"
            width="450px"
            :visible.sync="warningVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="warningVisible">
                <el-form label-position="left" label-width="120px">
                    <el-form-item label="挂账单位">{{ submitData.EntpCusName }}</el-form-item>
                    <el-form-item label="挂账限额">{{ maxCreditMoney }}</el-form-item>
                    <el-form-item label="已挂账金额">{{ ownMoney.toFixed(2) }}</el-form-item>
                    <el-form-item v-if="maxCreditMoney < ownMoney" label="超出限额"
                        ><span style="color: red; font-weight: 600">{{ (ownMoney - maxCreditMoney).toFixed(2) }}</span></el-form-item
                    >
                    <el-form-item v-if="maxCreditMoney > ownMoney && isForbid && creditType == '0'" label="结算周期"
                        ><span style="color: red; font-weight: 600">{{ creditDay }}天</span></el-form-item
                    >
                    <el-form-item v-if="maxCreditMoney > ownMoney && isForbid && creditType == '1'" label="结账日期"
                        ><span style="color: red; font-weight: 600">{{ creditDay }}号</span></el-form-item
                    >
                </el-form>
                <span v-if="maxCreditMoney < ownMoney" style="color: red; font-size: 16px">挂账单位已超限额，您需要向上级申请，是否继续？</span>
                <span v-if="maxCreditMoney > ownMoney && isForbid && creditType == '0'" style="color: red; font-size: 16px"
                    >挂账单位已超结算周期，您需要向上级申请，是否继续？</span
                >
                <span v-if="maxCreditMoney > ownMoney && isForbid && creditType == '1'" style="color: red; font-size: 16px"
                    >挂账单位已过结账日期，您需要向上级申请，是否继续？</span
                >
            </div>
            <div class="dialog-footer">
                <el-button
                    class="btn-primary"
                    size="small"
                    :disabled="rowFormLoading"
                    @click="
                        () => {
                            warningVisible = false;
                        }
                    "
                    >确认</el-button
                >
            </div>
        </el-dialog>
        <!-- 新增库存 - 包含车型选择 -->
        <addGoods v-if="addAPAutoVisible" :dialogFormVisible="addAPAutoVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></addGoods>
    </div>
</template>
<script>
import Vue from 'vue';
import tableSets from '@/components/common/tableSets_v2.vue';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import customerEdit from '@/components/business/customerManage/customerEdit';
import jointSets from '@/components/common/jointSets.vue';
import APMsg from '@/components/common/APMsg';
import APAutoMsg from '@/components/common/APAutoMsg';
import APHistory from '@/components/common/ARSaleHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import mixin from '@/mixins/mixin';
import logisticsCompanyEdit from '@/components/logistics/logisticsCompanyEdit';
import transInventory from '@/components/business/search/transInventory';
import addGoods from '@/components/business/search/addGoods';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APPurPlanDatas from '@/components/common/APPurPlanDatas';
import APPurchaseHistory from '@/components/common/ARPurchaseHistory';
import OwnDetails from '@/components/business/customerManage/ownDetails';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import vinSearch from '@/components/business/goods/vinSearchGoods';
import bindSeries from '@/components/business/goods/goodsBindSeries';
import contextMenu from '@/components/common/contextMenu';
import addGoodsToPurOrder from '@/components/business/goods/addGoodsToPurOrder';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        APMsg,
        APAutoMsg,
        APHistory,
        APQuoteHistory,
        printEngContent,
        logisticsCompanyEdit,
        transInventory,
        addGoods,
        tableSets,
        APInquiryHistory,
        APNeedInDatas,
        APNeedOutDatas,
        APPurPlanDatas,
        jointSets,
        APPurchaseHistory,
        OwnDetails,
        ElImageViewer,
        vinSearch,
        bindSeries,
        contextMenu,
        addGoodsToPurOrder
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.$refs.formMsg.resetFields();
                this.submitData = {
                    AuthCode: '',
                    SId: this.userMsg.EmployeeId,
                    WarehouseId: '',
                    WarehouseName: '',
                    FollowerId: '',
                    SubmissionState: false,
                    EntpCusOId: '',
                    ShipAmount: '',
                    DiscountAmount: '',
                    EntpCusId: '',
                    PayType: '',
                    ShipType: '',
                    FullAddress: '',
                    PhoneNum: '',
                    Remark: '',
                    DetailList: [],
                    LogisticId: '',
                    LogisticName: '',
                    LogisticItem: '',
                    LogisticsOrderNo: '',
                    DiscountType: 0,
                    DiscountRate: 0,
                    OrgId: '',
                    OrgName: '',
                    IsNeedLock: false,
                    Vin: '',
                    CusSources: '',
                    CusSourcesName: '',
                    IsAutoPrint: false
                };
                this.addressList = [];
                this.tableData = [];
                this.tableDataLength = 0;
                this.autoSeriesModel = null;
                this.isUseAS = false;
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
                this.ownMoney = 0;
                this.maxCreditMoney = 0;
                this.creditDay = 0;
                this.creditType = 0;
                this.isForbid = false;
                this.isPay = false;
                this.yxbPermission = true;
                //价格等级逻辑
                this.priceType = 0;
                this.pricePoint = 1;
                this.calcType = -1;
                this.imageVisible = false;
                this.currentRow = {};
                this.dataindex = 0;
                this.isShowSummary = false;
                this.summaryList = [];
                this.init();
            }
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        currentRow(newVal, oldVal) {
            this.srcList = [];
            if (newVal && newVal.MainImage && newVal.MainImage != oldVal.MainImage) {
                if (!this.imageVisible) {
                    this.$nextTick(() => {
                        this.imageVisible = true;
                    });
                }
            } else {
                this.imageVisible = false;
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        },
        getEditOrderStat(value) {
            this.updateDataList(value);
        }
    },
    computed: {
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;

            if (this.submitData.DiscountType === 2) {
                // 处理整单优惠
                discountCount = (this.submitData.DiscountRate / 100) * this.allMoney;
            }
            if (!discountCount || this.submitData.DiscountType === 0) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            return (this.allMoney * 1 - discountCount + shipAmount > 0 ? this.allMoney * 1 - discountCount + shipAmount : 0).toFixed(2);
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [0, 2, 3, 4, 8].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 收款金额是否大于零，当为true时，不能修改优惠金额
        hasPaid() {
            return this.submitData.Paid && this.submitData.Paid * 1 > 0;
        },
        // 是否新增，编辑，修改
        isEdit() {
            return [0, 2, 3, 4, 8].includes(this.type * 1);
        },
        logisLoading() {
            return this.loading;
        },
        cusLoading() {
            return this.loading;
        },
        getEditOrderStat() {
            return this.$store.state.updateEditOrder;
        }
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            odetailH: 314,
            isCheckCode: true,
            isCanTBSet: false,
            seriesVisible: false,
            isUseSE: false,
            downloadUrl: this.$util.QN_URL_BASE,
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            tableCode: 'SearchAP',
            isStartSearch: false,
            isStartConfirm: false,
            userMsg: userMsg,
            idList: [],
            addressList: [],
            typeList: [],
            brandList: [],
            postType: 0,
            isSearch: false,
            isShowPrintCHDlg: false,
            showDisc: true,
            isShowPrintEngDlg: false,
            dialogPrint: false,
            needConfirm: true,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            FollowerList: [],
            goodsId: '',
            loading: false,
            searchLoading: false,
            saving: false,
            warehouseType: 0,
            dataReadonly: false,
            showOrderMsg: true,
            showResultMsg: false,
            apMsgVisible: false,
            apAutoMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            jointSetVisible: false,
            dialogCusVisible: false,
            historyQuoteVisible: false,
            inqHistoryVisible: false,
            historyPurVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            purPlanDataVisible: false,
            vinSearchVisible: false,
            warningVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            purPlanTitle: '',
            rowVisible: false,
            rowForm: {},
            allNum: 0,
            allMoney: 0,
            customerEditType: 1,
            submitData: {
                AuthCode: '',
                SId: userMsg.EmployeeId,
                WarehouseId: '',
                WarehouseName: '',
                FollowerId: '',
                SubmissionState: false,
                EntpCusOId: '',
                ShipAmount: '',
                DiscountAmount: '',
                EntpCusId: '',
                PayType: '',
                ShipType: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                LogisticId: '',
                LogisticName: '',
                LogisticItem: '',
                LogisticsOrderNo: '',
                DiscountType: 0,
                DiscountRate: 0,
                OrgId: '',
                OrgName: '',
                IsNeedLock: false,
                Vin: '',
                CusSources: '',
                CusSourcesName: '',
                IsAutoPrint: false
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            codeList: [],
            dataList: [],
            unitList: [],
            warehouseList: [], //仓库列表
            warehouseGoodsList: [], //入库商品列表
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                ShipType: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'change'
                    }
                ],
                EntpCusId: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'change'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '请选择业务员',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'change'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '支付方式为必选项',
                        trigger: 'change'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [
                    {
                        required: true,
                        message: '请选择仓库',
                        trigger: 'change'
                    }
                ],
                OrgId: [
                    {
                        required: true,
                        message: '请选择部门',
                        trigger: 'change'
                    }
                ],
                CusSources: [
                    {
                        required: true,
                        message: '请选择来源',
                        trigger: 'change'
                    }
                ]
            },
            permission: {},
            funcConfig: false,
            discountOptions: [
                {
                    id: 0,
                    value: '无优惠'
                },
                {
                    id: 1,
                    value: '优惠金额'
                },
                {
                    id: 2,
                    value: '整单优惠'
                }
            ],
            LoseMoneyValue: 0, //亏本指标
            priceCanBeZero: false,
            priceCanBeEdit: false,
            changeCodeConfig: false,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            isSSetConfig: false,
            selectedData: [],
            logisticsList: [],
            yxbPermission: true, //修改订单时，只有易询宝付款后的订单能修改物流数据，其他都不能动
            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            logisForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            // 新增和编辑物流公司参数
            lceParams: {
                id: '',
                type: 1, // 1 新增，2 编辑
                title: '',
                visible: false
            },
            // 提交后是否展示到下次订单中？
            customerChecked: false,
            saveCustomerCache: false,
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            isBPriceShow: false, //开单价
            isOriginShow: false, //产地
            isUrgentShow: false, //急件
            isSizeShow: false, //规格
            isUnUseDFSend: false, //开启则不适用默认发货方式
            isOrgShow: false, //开单部门
            isLastOrg: false, //默认上次开单部门
            oldOrgId: '', //记录原有部门id，在修改编辑的时候如果没更改过部门不需要更新最后一次开单部门
            isLockVIN: false,
            orgList: [], //
            tableData: [],
            tableDataLength: 0,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                AutoSeriseId: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            },
            columnShowSets: [],
            tableSetsVisible: false,
            separator: '',
            scrollTop: 0,
            scrollLeft: 0,
            askShowDisc: false, //询问是否打印订单优惠价格
            isDefaultSet: false, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            timer: null, //保存setTimeout定时器对象
            isRegister: false,
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            rowFormLoading: false,
            ownMoney: 0,
            isImagePreview: false,
            imageVisible: false,
            srcList: [],
            showViewer: false,
            isShowSummary: false,
            summaryList: [],
            isOriginSort: false,
            isBrandSort: false,
            autoSeriesModel: null,
            apCodeCallBack: '',
            nameCallBack: '',
            autoCallBack: '',
            originCallBack: '',
            isUseAS: false,
            maxCreditMoney: 0,
            today: 0,
            creditDay: 0,
            creditType: 0,
            isCheckPrice: false, //检查售价不能低于设置的销售价
            isCheckPriceCS: false, //检查售价不能低于成本价
            authCode: '',
            referPrice: '最新报价（针对客户）价格或当前销售价',
            profitRate: 0,
            isCheckCredit: false,
            isShowOwn: false,
            isForbid: false, //限制开单
            isPay: false, //是否财务确认
            isPaySpecial: false, //是否挂账（当限制开单后，只能是false）
            pricePoint: 1,
            priceType: 0,
            calcType: -1,
            IsNoZeroGoods: false, //是否禁止添加库存为零的商品
            refPriceToPrice: false, //是否将参考价赋值给价格
            menuVisible: false,
            menuList: [{ title: '增加采购单', value: 0, command: 'addPurOrder' }],
            aToPurOrderVisible: false, //显示添加商品到采购单弹窗
            isUseSource: false, //是否启用销售开单显示来源
            cusSourcesList: [],
            isAutoDialog: false, //配件弹窗具备车型功能
            addAPAutoVisible: false,
            isShowBrand: false, //是否显示品牌
            isExObj_APCode: false,
            isExObj_GoodName: false,
            isExObj_AutoSerise: false,
            isExObj_GoodCode: false,
            isExObj_Cate: false,
            isExObj_Brand: false,
            isExObj_Inventory: false,
            isExObj_Size: false,
            isExObj_Origin: false,
            isExObj_GoodDesc: false,
            isAutoPrint: false,
            isPrintWH2: false,
            isDefaultWH: false, //是否默认上一次开单的仓库
            IsMPrice: false, //加入清单弹窗默认价格零售价
            submitStorageName:'salesOrder',
            dataStorageName:'salesOrder_dataList',
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.removeEventListener('keydown', this.handleKeyEvent);
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSendWay();
        this.getPay();
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
        this.today = new Date().getDate();
    },
    mounted() {
        let that = this;
        that.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        //加载组件
        that.getPrintComponents();

        let authCode = this.$util.getLocalStorage('sorder_authcode');
        if (authCode) {
            that.authCode = authCode;
        } else {
            let timestamp = new Date().getTime();
            let str = that.userMsg.EmployeeId + timestamp;
            that.$util.md5(str).then(data => {
                that.authCode = data;
                that.$util.setLocalStorage('sorder_authcode', data);
            });
        }
    },
    methods: {
        change(e, type) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].BillingPrice = that.rowForm._biilPrice;
                    that.dataList[fIdx].Count = that.rowForm._count;
                    that.dataList[fIdx].MarketPrice = that.rowForm._price;
                }
            } else {
                if (type === 1) that.rowForm._biilPrice = e;
            }
        },
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            if (that.aToPurOrderVisible) return;
            let key = window.event.keyCode;
            //打印弹窗
            if (that.isShowPrintCHDlg || that.isShowPrintEngDlg) {
                e.preventDefault();
                return;
            }
            //提交订单后的提示弹窗的按钮事件
            if (that.dialogPrint) {
                e.preventDefault();
                // 仅提交(F1)
                if (key == 112) that.printAndSubmit(0);
                // 提交并打印(F2)
                else if (key == 113 && (that.warehouseType == 0 || that.isPrintWH2) && (that.permission.print || that.permission.printPreview)) that.printAndSubmit(1);
                // 提交并自动打印(F3)
                else if (key == 114 && (that.warehouseType == 0 || that.isPrintWH2) && that.isAutoPrint && (that.permission.print || that.permission.printPreview))
                    that.printAndSubmit(3);
                // 提交，打印英文版(F4)
                else if (key == 115 && that.permission.printEng) that.printAndSubmit(2);
                return;
            }

            if (key === 107) {
                if (!that.searchVisible) that.addItem(false);
                return;
            }
            if (key == 112) {
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            if (key == 114) {
                e.preventDefault();
                that.showAPMsgDialog();
                return;
            }
            if (key == 115) {
                e.preventDefault();
                if (!that.historyQuoteVisible && that.permission.quoteHistory && !that.searchVisible) that.showHistories();
                else if (that.searchVisible) {
                    that.vinSearch();
                }
                return;
            }
            if (key == 116) {
                e.preventDefault();
                if (!that.historyVisible && that.permission.salesHistory) that.showHistoryDialog();
                return;
            }
            if (key == 117) {
                e.preventDefault();
                if (!that.historyPurVisible && that.permission.purHistory) that.showPurHistories();
                return;
            }
            if (key == 118) {
                if (that.permission.AddLogistics) {
                    e.preventDefault();
                    that.lceHandle(1);
                }

                return;
            }
            if (key == 119) {
                if (that.submitData.LogisticId && that.permission.EditLogistics) {
                    e.preventDefault();
                    if (that.submitData.LogisticId) that.lceHandle(2);
                }
                return;
            }
            if (key == 120) {
                //F9
                if (that.permission.addCustomer && that.type != 8 && that.type != 4) {
                    e.preventDefault();
                    that.addCustomer(1);
                }

                return;
            }
            if (key == 121) {
                //F10
                if (that.permission.editCustomer && that.submitData.EntpCusId && that.type != 8 && that.type != 4) {
                    e.preventDefault();
                    if (that.submitData.EntpCusId) that.addCustomer(2);
                }
                return;
            }
            if (key == 122) {
                //F11
                if (!(that.permission.save && that.type != 8)) {
                    e.preventDefault();
                    return;
                }

                if (that.isForbid && that.isPaySpecial) {
                    e.preventDefault();
                    that.warningVisible = true;
                    return;
                }

                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.apAutoMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible
                ) {
                    e.preventDefault();
                    that.submitForm(that.type, 0);
                    return;
                }

                return;
            }
            if (key == 123) {
                //F12
                if (that.isForbid && that.isPaySpecial) {
                    e.preventDefault();
                    that.warningVisible = true;
                    return;
                }

                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.addAPAutoVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.apAutoMsgVisible &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible
                ) {
                    e.preventDefault();
                    that.submitForm(that.type, 1);
                    return;
                }
                return;
            }
            if (key === 13) {
                //Enter
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.apAutoMsgVisible &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible &&
                    !that.aToPurOrderVisible &&
                    !that.warningVisible
                ) {
                    e.preventDefault();
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading) that.rowConfirm();
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        (!that.$refs.search_5 || (that.$refs.search_5 && !that.$refs.search_5.visible)) &&
                        (!that.$refs.search_6 || (that.$refs.search_6 && !that.$refs.search_6.visible)) &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }
                return;
            }
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                that.imageVisible = false;
                that.vinSearchVisible = false;
                if (
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) ||
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_9 && that.$refs.search_9.suggestionVisible)
                ) {
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_9 && that.$refs.search_9.suggestionVisible) that.$refs.search_9.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                //ESC
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.apAutoMsgVisible &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible
                ) {
                    e.preventDefault();
                    if (that.searchVisible && !that.rowVisible) {
                        that.searchVisible = false;
                        that.isStartSearch = false;
                    } else if (!that.searchVisible && that.rowVisible) {
                        that.rowVisible = false;
                        that.isStartConfirm = false;
                    }
                    if (that.isAutoDialog) that.apAutoMsgVisible = false;
                    else that.apMsgVisible = false;
                }
                return;
            }
            //下键
            if (key == 40) {
                if (that.menuVisible) that.menuVisible = false;
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyPurVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.apAutoMsgVisible &&
                    !that.showViewer &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        var cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    //两个定位是为了确认选中行一定在当前展示中
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                            if (that.dataindex > that.tableData.length - 10 && !that.searchLoading && that.dataindex < that.tableDataLength - 14) that.downKeyToLoad();
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }

                                that.searchIndex += 1;
                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex < 10) {
                                    that.searchIndex += 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                if (that.menuVisible) that.menuVisible = false;
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.historyPurVisible &&
                    !that.inqHistoryVisible &&
                    !that.isShowPrintCHDlg &&
                    !that.isShowPrintEngDlg &&
                    !that.dialogPrint &&
                    !that.lceParams.visible &&
                    !that.addAPVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.apAutoMsgVisible &&
                    !that.showViewer &&
                    !that.seriesVisible &&
                    !that.vinSearchVisible
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;

                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex > 0) {
                                    that.searchIndex -= 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'kdbjsd',
                    'ddhhm',
                    'sjqx',
                    'kdyjz',
                    'xsgdy',
                    'xskbzb',
                    'xsspjgwl',
                    'xgxsjg',
                    'lybsdr',
                    'xskdxskdj',
                    'xskdxskdbm',
                    'kdbmmrsycxz',
                    'xwdyxxdxxyh',
                    'syllqdysz',
                    'dyyl',
                    'kdjzfhfs',
                    'kdspcd',
                    'kdspgg',
                    'xskdmrcdpx',
                    'kdmrpppx',
                    'kcspssyq',
                    'ssckjbdylr',
                    'spsjbdycb',
                    'skdckjlr',
                    'khgzzq',
                    'xskdjzkcl',
                    'mrbdcxsj',
                    'ckjfgjg',
                    'xsddly',
                    'kdxspp',
                    'ygsfkzdylb',
                    'xzqpbmdwyx',
                    'tstjqpauto',
                    'xsdjdybszddy',
                    'tjbdyqzcdd',
                    'xsdbsjj',
                    'xskdmrck',
                    'xskdtcjg'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'kdbjsd':
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm':
                                    this.changeCodeConfig = result;
                                    break;
                                case 'sjqx':
                                    this.isSSetConfig = result;
                                    break;
                                case 'kdyjz':
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xsgdy':
                                    this.funcConfig = result;
                                    break;
                                case 'xskbzb':
                                    this.LoseMoneyValue = result ? Number(rValue) : 0;
                                    break;
                                case 'xsspjgwl':
                                    this.priceCanBeZero = result;
                                    break;
                                case 'xgxsjg':
                                    this.priceCanBeEdit = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kdbmmrsycxz':
                                    this.isLastOrg = result;
                                    break;
                                case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                    this.askShowDisc = result;
                                    break;
                                case 'syllqdysz': //是否使用浏览器的打印功能
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                                case 'kdjzfhfs': //开启则不适用默认发货方式
                                    this.isUnUseDFSend = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xskdmrcdpx': //是否默认产地排序
                                    this.isOriginSort = result;
                                    break;
                                case 'kdmrpppx': //是否默认品牌排序
                                    this.isBrandSort = result;
                                    break;
                                case 'kcspssyq': //使用搜索引擎
                                    this.isUseSE = result;
                                    break;
                                case 'ssckjbdylr': //开启检查销售价的限制
                                    this.isCheckPrice = result;
                                    break;
                                case 'spsjbdycb': //开启检查销售价的低于成本价限制
                                    this.isCheckPriceCS = result;
                                    break;
                                case 'skdckjlr': //参考价的利润率
                                    this.profitRate = result ? Number(rValue) : 0;
                                    if (result) this.referPrice = '参考价 = 成本价 x ( 1 + ' + this.profitRate + '%)';
                                    break;
                                case 'khgzzq': //开启挂账限制
                                    this.isCheckCredit = result;
                                    break;
                                case 'xskdjzkcl': //禁止添加库存为零的商品
                                    this.IsNoZeroGoods = result;
                                    break;
                                case 'mrbdcxsj': //是否默认绑定VIN与配件数据
                                    this.isLockVIN = result;
                                    break;
                                case 'ckjfgjg': //是否将参考价赋值给价格
                                    this.refPriceToPrice = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'tstjqpauto': //配件弹窗展示车型
                                    this.isAutoDialog = result;
                                    break;
                                case 'xsdjdybszddy':
                                    this.isAutoPrint = result;
                                    break;
                                case 'tjbdyqzcdd': //提交并打印前置仓的订单
                                    this.isPrintWH2 = result;
                                    break;
                                case 'xsdbsjj': //展示急件
                                    this.isUrgentShow = result;
                                    break;
                                case 'xskdmrck': //是否默认上一次开单的仓库
                                    this.isDefaultWH = result;
                                    break;
                                case 'xskdtcjg':
                                    this.IsMPrice = result; //加入清单弹窗默认价格零售价
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                    that.isRegister = true;
                }
            });
        },
        showAddAPDialog() {
            if (this.isAutoDialog) this.addAPAutoVisible = true;
            else this.addAPVisible = true;
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            let that = this;

            if (!row) {
                if (that.isAutoDialog) that.addAPAutoVisible = false;
                else that.addAPVisible = false;
                return;
            } else {
                //移除最后一个空的配件
                if (that.dataList.length > 0 && !that.dataList[that.dataList.length - 1].EntpTempGoodsId) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                }
                that.dataList.push({
                    ...row,
                    Count: that.initNumber,
                    canEdit: true,
                    State: 0,
                    StorageInventory: 0,
                    OrderWaitOutQuantity: 0,
                    POrderWaitInQuantity: 0,
                    // BillingPrice: 0
                    BillingPrice: row.MarketPrice
                });
                if (that.isAutoDialog) that.addAPAutoVisible = false;
                else that.addAPVisible = false;
            }
            this.priceChange();
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                // this.$refs[ref].select();
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        //通过获取当前事件同上，但是第一加载也有同样的问题，该方法没使用，只是做个记录
        selectAutoHandle2(e) {
            e.currentTarget.select();
        },
        // 新增和编辑物流公司
        lceHandle(type) {
            this.lceParams = {
                id: type === 2 ? this.submitData.LogisticId : '',
                type,
                title: `${type === 2 ? '编辑' : '新增'}物流公司`,
                visible: true
            };
        },
        // 关闭物流弹框
        closeLceDialog(edit) {
            this.lceParams.visible = false;
            if (edit) {
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
                this.searchLogistic();
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        async init() {
            this.permission = this.$util.getPermission('salesOrder');

            this.id = this.$route.query.id;
            this.submitData.EntpCusOId = this.$route.query.id;
            this.type = Number(this.$route.query.type);


            if(this.type==0){
                this.submitStorageName=this.submitStorageName+'_add';
                this.dataStorageName=this.dataStorageName+'_add';                
            } else if(this.type==3){
                this.submitStorageName=this.submitStorageName+'_copy';
                this.dataStorageName=this.dataStorageName+'_copy';                
            }else if(this.type==4){
                this.submitStorageName=this.submitStorageName+'_trans';
                this.dataStorageName=this.dataStorageName+'_trans';                
            }else if(this.type==9){
                this.submitStorageName=this.submitStorageName+'_purtrans';
                this.dataStorageName=this.dataStorageName+'_purtrans';                
            }
            let salesOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);

            await this.$util.GetEntpCache({ CacheKey: 'salesOrder_saveCustomerCache' }, true).then(data => {
                if (data) {
                    this.saveCustomerCache = JSON.parse(data);
                }
            });

            switch (this.type) {
                case 2:
                    this.pageTitle = '编辑销售单';
                    await this.getConfigByCodes().then(() => {
                        //判断缓存是否有数据，如果有取缓存数据
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 0:
                    this.pageTitle = '新增销售单';
                    this.autoSeriesModel = this.$util.getLocalStorage('vin_createParams');
                    if (this.autoSeriesModel) {
                        this.isUseAS = true;
                        this.$util.clearLocalStorage('vin_createParams');
                        this.showSearch();
                    }
                    await this.getConfigByCodes().then(() => {
                        if (datalist && datalist.length > 0) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        } else {
                            //判断是否从我的网销商品页面过来
                            let siGoodsIds = this.$util.getLocalStorage('SI_GoodsData');
                            if (siGoodsIds) {
                                this.$util.clearLocalStorage('SI_GoodsData');
                                this.pageTitle = '转为销售单';
                                this.getDataByGoodsIds(siGoodsIds);
                            } else {
                                this.getdefaultWarehouses();
                            }
                            if (this.$refs.cusselect && !this.autoSeriesModel) this.$refs.cusselect.focus();
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                    });

                    break;
                case 4:
                    this.pageTitle = '转为销售单';
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getBJOrder();
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                    });
                    break;
                case 3:
                    this.pageTitle = '复制订单';
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 8:
                    this.pageTitle = '修改订单';
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 9:
                    this.pageTitle = '采购转销售单';
                    this.submitData.QuoteId = this.$route.query.pid;
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderforSales();
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                    });
                    if (this.$refs.cusselect) this.$refs.cusselect.focus();
                    break;
                default:
                    break;
            }

            if (!this.submitData.FollowerId && this.funcConfig) {
                this.getSalesOrderFollower();
            }
        },
        refresh() {
            this.$router.replace({
                path: '/salesManage/salesOrder/edit_v3',
                query: { id: '', type: 0, _t: Date.now() }
            });
            this.saving = false;
        },
        closePrintDialog(action) {
            let that = this;
            that.dialogPrint = false;
            that.isShowPrintCHDlg = false;
            that.isShowPrintEngDlg = false;

            //打印并继续开单
            if (action == 'continueToOrder') {
                setTimeout(() => {
                    // if (that.type != 0) that.refresh(); //这刷新方式如果是新增订单时不起作用，应该是参数没有发生变化导致
                    // else that.$router.go(0);//编辑订单时无法清空路由的参数
                    that.refresh();
                }, 1000);
            } else {
                //打印并返回列表或者直接返回列表
                setTimeout(() => {
                    this.$router.push('/salesManage/salesOrder');
                }, 1000);
            }
        },
        canclePrint() {
            this.dialogPrint = false;
        },
        getSIdList() {
            if (this.isSSetConfig) {
                this.$util.getAuthSIdList().then(data => {
                    this.SIdList = data;
                });
                this.$util.getSIdList().then(data => {
                    this.FollowerList = data;
                });
            } else {
                this.$util.getSIdList().then(data => {
                    this.SIdList = data;
                    this.FollowerList = data;
                });
            }
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        closeSearchDialog() {
            // this.searchVisible = false;
            this.isStartSearch = false;
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (!that.apMsgVisible && !that.isAutoDialog) {
                if (id) {
                    that.goodsId = id;
                    that.apMsgVisible = true;
                } else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                    that.goodsId = that.currentRow.EntpTempGoodsId;
                    that.apMsgVisible = true;
                }
            } else if (that.isAutoDialog && !that.apAutoMsgVisible) {
                if (id) {
                    that.goodsId = id;
                    that.apAutoMsgVisible = true;
                } else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                    that.goodsId = that.currentRow.EntpTempGoodsId;
                    that.apAutoMsgVisible = true;
                }
            }
        },
        closeAPMsgDialog(edit) {
            if (this.isAutoDialog) this.apAutoMsgVisible = false;
            else this.apMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
            this.historyPurVisible = false;
        },
        //历史报价
        showHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.historyQuoteVisible = true;
            }
        },
        //历史采购
        showPurHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.historyPurVisible = true;
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            if (this.$refs.cusselect) this.$refs.cusselect.blur();

            if (!this.showOrderMsg && !this.showResultMsg) this.odetailH = 680;
            else this.odetailH = 314;
        },
        showMsg() {
            this.showOrderMsg = true;

            if (!this.showOrderMsg && !this.showResultMsg) this.odetailH = 680;
            else this.odetailH = 314;
        },
        hideResultFunc() {
            this.showResultMsg = false;

            if (!this.showOrderMsg && !this.showResultMsg) this.odetailH = 680;
            else this.odetailH = 314;
        },
        showResultFunc() {
            this.showResultMsg = true;

            if (!this.showOrderMsg && !this.showResultMsg) this.odetailH = 680;
            else this.odetailH = 314;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
        },
        closeDialog(edit, entpCusId, entpCusName) {
            let that = this;
            if (edit != 'edit') {
                if (edit == 'used' && entpCusId) {
                    that.submitData.EntpCusId = entpCusId;
                    if (!that.submitData.EntpCusName) that.submitData.EntpCusName = entpCusName;
                    that.getDefaultData();
                } else that.searchCustomer();
            } else if (edit == 'edit' && entpCusId) {
                if (entpCusId == that.submitData.EntpCusId) {
                    that.getDefaultData();
                }
            }
            that.dialogCusVisible = false;
            that.tableSetsVisible = false;
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogCusVisible = true;
        },
        // 报价单转销售单详情
        getBJOrder() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrderToSaleOrder',
                    data: {
                        QuoteId: this.id,
                        EntpId: this.userMsg.EntpId,
                        WarehouseId: this.submitData.WarehouseId
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;

                    this.submitData.QuoteId = this.id;
                    this.submitData.UserId = this.userMsg.EmployeeId;
                    this.submitData.EntpCusId = data.EntpCusId;
                    this.submitData.EntpCusName = data.EntpCusName;
                    this.submitData.PhoneNum = data.PhoneNum;
                    this.submitData.FullAddress = data.FullAddress;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        // DetailList[i].BillingPrice = DetailList[i].MarketPrice == 0 ? '' : DetailList[i].MarketPrice;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                    if (data.Warehouse) {
                        this.warehouseList = [];
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    this.getDefaultData();
                });
        },
        //采购转销售
        getOrderforSales() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetOrderforSales',
                    data: {
                        EntpCusPOId: this.submitData.QuoteId
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                    if (data.Warehouse) {
                        this.warehouseList = [];
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    //采购转销售是没有客户的
                    // this.getDefaultData();
                })
                .catch(() => {});
        },
        //根据商品id获取销售单商品
        getDataByGoodsIds(ids) {
            let that = this;
            this.getdefaultWarehouses();
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetDataByGoodsIds',
                    data: {
                        sId: that.submitData.WarehouseId,
                        ids: ids
                    }
                })
                .then(res => {
                    let DetailList = res.data;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                })
                .catch(() => {});
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpCusSaleOrder',
                    data: {
                        EntpCusOId: this.id,
                        Type: this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    data.LogisticItem = data.LogisticName;

                    if (data.Vin) {
                        if (!this.autoSeriesModel) this.autoSeriesModel = {};
                        this.autoSeriesModel.VIN = data.Vin;
                        this.autoSeriesModel.AutoSeries = data.AutoSeries;
                        this.autoSeriesModel.AutoSeriesId = data.AutoSeriesId;
                        this.isLockVIN = data.IsNeedLock;
                    }

                    this.ownMoney = data.OwnMoney;
                    this.maxCreditMoney = data.MaxCreditMoney;
                    this.creditDay = data.CreditDay;
                    this.creditType = data.CreditType;
                    this.isForbid = data.IsForbid;
                    this.isPay = data.IsPay;

                    if (data.Sources == 4 && data.IsPay) {
                        this.yxbPermission = false;
                    }
                    // 判断是否可编辑
                    if (this.type != 0 && this.type != 2 && this.type != 3 && this.type != 4 && this.type != 8) {
                        this.dataReadonly = true;
                    }
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName,
                        CallNum: data.PhoneNum,
                        FullAddress: data.FullAddress
                    });

                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == data.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: data.SId,
                            EmployeeName: data.SName
                        });
                    }

                    this.FollowerList.push({
                        EmployeeId: data.FollowerId,
                        EmployeeName: data.FollowerName
                    });

                    if (this.isOrgShow && res.data.OrgId) {
                        this.oldOrgId = res.data.OrgId;
                        this.orgList.push({
                            Id: data.OrgId,
                            Name: data.OrgName
                        });
                    }
                    if (this.isUseSource && data.CusSources) {
                        this.cusSourcesList = [];
                        this.cusSourcesList.push({ Text: data.CusSourcesName, Value: data.CusSources });
                    }

                    this.submitData = data;
                    if (!this.submitData.SId) this.submitData.SId = this.userMsg.EmployeeId;

                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.Type
                        });
                        this.warehouseType = data.Warehouse.Type;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.Type);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    } else {
                        this.getdefaultWarehouses();
                    }

                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        this.$set(DetailList[i], 'MarketPrice', DetailList[i].Price);
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    //价格等级逻辑
                    this.priceType = data.PriceType;
                    this.pricePoint = data.PricePoint;
                    this.calcType = data.CalcType;

                    this.allMoney = _allMoney.toFixed(2);
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        // 提交销售单
        submitForm(type, SubmissionState) {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;

                    if (_dataList.length == 0) {
                        this.$util.warningMsg('您还未选择任何的商品数据哟');
                        return;
                    }
                    if (!this.submitData.EntpCusId) {
                        this.$util.warningMsg('请选择客户');
                        this.showMsg();
                        return;
                    }
                    if (this.submitData.LogisticsOrderNo && !this.submitData.LogisticId) {
                        this.$util.warningMsg('请选择物流公司，否则物流单号将无法保存');
                        this.showMsg();
                        return;
                    }
                    if (this.submitData.DiscountType === 2) {
                        // 处理整单优惠
                        this.submitData.DiscountAmount = (this.submitData.DiscountRate / 100) * this.allMoney;
                    }
                    if (this.submitData.DiscountAmount > this.allMoney && !this.priceCanBeZero) {
                        this.$util.warningMsg('优惠金额不能大于订单总额');
                        return;
                    }

                    if (this.submitData.PayType) {
                        let ml = this.payWayList.filter(f => f.Value === this.submitData.PayType);
                        if (ml.length > 0) {
                            let m = ml[0];
                            if (m.IsSecSpecial) {
                                if (!this.submitData.LogisticId) {
                                    this.$util.warningMsg('当支付方式为托收类型时，物流公司必须进行选择');
                                    return;
                                }
                            }
                        } else {
                            this.$util.warningMsg('支付方式异常，请重新选择支付方式');
                            return;
                        }
                    }

                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        let msg = '第' + (i + 1) + '项商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】';
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg(msg + '已删除');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg(msg + '请填写车型');
                            return;
                        }
                        if (!_dataList[i].Count || _dataList[i].Count < 0) {
                            this.$util.warningMsg(msg + '请填写正确的数量');
                            return;
                        } else {
                            if (!_dataList[i].IsDelivery && _dataList[i].WarehousedCount > 0 && _dataList[i].Count < _dataList[i].WarehousedCount) {
                                this.$util.warningMsg(msg + '商品数量不能少于已出仓数，已出仓' + _dataList[i].WarehousedCount + '个商品');
                                return;
                            }
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg(msg + '请填写单位');
                            return;
                        }
                        if (!this.priceCanBeZero) {
                            if (!_dataList[i].MarketPrice && !_dataList[i].Price) {
                                this.$util.warningMsg(msg + '请填写销售价');
                                return;
                            }
                        }

                        if (this.IsNoZeroGoods && SubmissionState == 1) {
                            if (_dataList[i].StorageInventory == 0 && _dataList[i].WarehousedCount < _dataList[i].Count) {
                                this.$util.warningMsg(`${msg}当前库存商品为零,不可提交订单`);
                                return;
                            }else if (type == 4 && _dataList[i].StorageInventory == 0) {  ///报价转销售单不会返回WarehousedCount字段
                                this.$util.warningMsg(`${msg}当前库存商品为零,不可提交订单`);
                                return;
                            }
                        }
                        _dataList[i].Price = _dataList[i].MarketPrice;
                    }

                    this.postType = type;
                    this.submitData.DetailList = _dataList;
                    this.submitData.SubmissionState = SubmissionState;
                    this.submitData.AuthCode = this.authCode;
                    this.submitData.Vin = this.autoSeriesModel && this.autoSeriesModel.VIN ? this.autoSeriesModel.VIN : '';
                    this.submitData.IsNeedLock = this.isLockVIN;

                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;
                                this.submitBefore(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submitBefore(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        // 提交前确认
        submitBefore(SubmissionState) {
            switch (SubmissionState) {
                case 0: //保存
                    this.submit(0); //不打印
                    break;
                case 1: //提交
                    this.dialogPrint = true;
                    break;
            }
        },
        //弹窗后的提交 -- 先验证
        printAndSubmit(printType) {
            if (this.isCheckPrice) {
                this.checkPriceToConfirm(printType);
            } else {
                this.submit(printType);
            }
        },
        submit(printType) {
            let that = this;
            if (that.saving) return;
            that.saving = true; //防止多次点击
            that.dialogPrint = false;
            //自动打印
            if (printType == 3) that.submitData.IsAutoPrint = true;

            let type = Number(that.postType);
            let url = '';
            switch (type) {
                case 2: // 2 是编辑（未提交前）；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 0: // 3 是新增；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 8: // 8 是修改（提交后）
                    url = '/api/EntpSaleOrder/SaveAfterSubmit';
                    break;
                case 3: // 7 是重新开单
                    url = '/api/EntpSaleOrder/RebuildSaleOrder';
                    break;
                case 9: //采购转销售
                    url = '/api/EntpSaleOrder/TransformPurOrder';
                    break;
                default:
                    //4 报价转为销售单
                    url = '/api/EntpSaleOrder/TransformQuotationOrder';
                    break;
            }
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.needConfirm = false;

                        that.idList = [];
                        if (res.data) {
                            //新增
                            that.idList.push(res.data);
                            that.submitData.EntpCusOId = res.data;
                        } else {
                            //修改
                            that.idList.push(that.id);
                        }

                        if (type == 0 || type == 1 || type == 2 || type == 3) {
                            let name = '';
                            switch (that.submitData.SubmissionState) {
                                case 0:
                                    name = '保存';
                                    break;
                                case 1:
                                    name = '提交';
                                    break;
                            }
                            that.$util.successMsg(name + '销售订单成功');
                        } else if (type == 8) {
                            that.$util.successMsg('修改销售订单成功');
                        } else {
                            that.$util.successMsg('转为销售订单成功');
                        }
                        //清除销售订单缓存
                        that.removePageChace();

                        let CacheList = [];

                        //添加默认出仓仓库
                        if (that.submitData.WarehouseId) {
                            var wd = {
                                WarehouseId: that.submitData.WarehouseId,
                                WarehouseName: that.submitData.WarehouseName,
                                WarehouseType: that.warehouseType
                            };
                            CacheList.push({ CacheKey: 'defaultOutWarehouses', CacheValue: JSON.stringify(wd), CacheType: '1' });
                        }

                        //添加默认部门
                        if (
                            that.isOrgShow &&
                            that.isLastOrg &&
                            that.submitData.OrgId &&
                            (that.type == 0 ||
                                that.type == 3 ||
                                that.type == 4 ||
                                that.type == 7 ||
                                that.type == 9 ||
                                ((that.type == 2 || that.type == 8) && that.oldOrgId != that.submitData.OrgId))
                        ) {
                            var og = {
                                OrgId: that.submitData.OrgId,
                                OrgName: that.submitData.OrgName
                            };
                            CacheList.push({ CacheKey: 'LastOrderOrg', CacheValue: JSON.stringify(og), CacheType: '1' });
                        }
                        if (that.submitData.FollowerId && that.funcConfig) {
                            let fo = that.FollowerList.filter(f => f.EmployeeId == that.submitData.FollowerId);
                            if (fo) {
                                var follower = {
                                    FollowerId: that.submitData.FollowerId,
                                    FollowerName: fo[0].EmployeeName
                                };
                                CacheList.push({ CacheKey: 'salesOrder_follower', CacheValue: JSON.stringify(follower) });
                            }
                        }

                        // 添加缓存：提交后是否展示到下次订单中
                        CacheList.push({ CacheKey: 'salesOrder_saveCustomerCache', CacheValue: that.customerChecked });

                        that.$util.SetEntpCache(CacheList);
                        //保存需要更新的订单，列表刷新使用
                        that.$store.commit('updateNeedRefresh', true);
                        if (type != 2 && type != 8) {
                            if (that.$store.state.orderData && that.$store.state.orderData.Id)
                                that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: true, Refresh: true });
                            else that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: true });
                        } else {
                            that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: false });
                        }

                        switch (printType) {
                            case 1:
                                if (
                                    !that.askShowDisc ||
                                    that.submitData.DiscountType == 0 ||
                                    (that.submitData.DiscountType == 1 && that.submitData.DiscountAmount == 0) ||
                                    (that.submitData.DiscountType == 2 && that.submitData.DiscountRate == 0)
                                ) {
                                    if (that.isDefaultSet) that.isShowPrintCHDlg = true;
                                    else if (that.permission.printPreview && !that.permission.print) {
                                        that.isShowPrintCHDlg = true;
                                    } else {
                                        that.$refs.printDom.init(true);
                                    }
                                } else {
                                    that.showDisc = true;
                                    that.$confirm('是否打印显示优惠价？', '提示', {
                                        confirmButtonText: '是',
                                        cancelButtonText: '否',
                                        type: 'warning'
                                    })
                                        .then(() => {
                                            that.showDisc = true;
                                            if (that.isDefaultSet) that.isShowPrintCHDlg = true;
                                            else if (that.permission.printPreview && !that.permission.print) {
                                                that.isShowPrintCHDlg = true;
                                            } else {
                                                that.$refs.printDom.init(true);
                                            }
                                        })
                                        .catch(() => {
                                            that.showDisc = false;
                                            if (that.isDefaultSet) that.isShowPrintCHDlg = true;
                                            else if (that.permission.printPreview && !that.permission.print) {
                                                that.isShowPrintCHDlg = true;
                                            } else {
                                                that.$refs.printDom.init(true);
                                            }
                                        });
                                }
                                break;
                            case 2:
                                that.isShowPrintEngDlg = true;
                                break;
                            case 0:
                            case 3:
                                setTimeout(() => {
                                    that.$router.push('/salesManage/salesOrder');
                                }, 2000);
                                break;
                        }
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        checkPriceToConfirm(printType) {
            let that = this;
            let type = Number(that.postType);
            that.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/CheckGoodsForSave',
                    data: that.submitData
                })
                .then(res => {
                    if (res.data.IsNeedPwd) {
                        let remark = res.data.Content;
                        that.$prompt(remark, '请输入管理员的密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            // inputPattern: /.{1,18}/,
                            inputType: 'password'
                            // inputErrorMessage: '请输入18字以内的数字或字母！'
                        })
                            .then(({ value }) => {
                                that.$util
                                    .axiosPost({
                                        url: 'api/EntpSaleOrder/AuthForSaveOrder',
                                        data: {
                                            AuthCode: that.authCode,
                                            Pwd: value,
                                            OrderId: type == 4 || type == 9 ? '' : that.submitData.EntpCusOId,
                                            DetailList: that.submitData.DetailList
                                        }
                                    })
                                    .then(res => {
                                        that.$util.successMsg('授权成功');
                                        that.submit(printType);
                                    })
                                    .catch(() => {});
                            })
                            .catch(() => {});
                    } else that.submit(printType);
                })
                .catch(() => {});
        },
        // 删除某行
        delItem(index, item) {
            let that = this;
            if (that.dataList.length != 1) {
                that.dataList.splice(index, 1);
            }
            that.priceChange();
            that.addPageChace(); //添加销售订单缓存

            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = false;
            }
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].MarketPrice) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加销售订单缓存
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            this.dataList.push({
                WaitingOutQuantity: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                ReferencePrice: 0,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: this.initNumber,
                MarketPrice: '',
                CostPrice: 0,
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                WarehousedCount: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                LatestSalesTime: '',
                LatestQuoteTime: '',
                BillingPrice: '',
                Origin: '',
                Size: '',
                Brand: ''
            });

            this.priceChange();
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'countRef') {
                setTimeout(() => {
                    this.$refs[`countRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
            this.$util.clearLocalStorage('sorder_authcode');
        },
        //从缓存中读取数据
        getDataFromChace() {
            return new Promise(resolve => {
                let salesOrderModel = this.$util.getLocalStorage(this.submitStorageName);
                let datalist = this.$util.getLocalStorage(this.dataStorageName);
                if (salesOrderModel) {
                    if (this.isUseSource && salesOrderModel.CusSources) {
                        this.cusSourcesList = [];
                        this.cusSourcesList.push({ Text: salesOrderModel.CusSourcesName, Value: salesOrderModel.CusSources });
                    }
                    this.submitData = salesOrderModel;
                    let isexit = this.customerList.find(e => e.EntpCusId == salesOrderModel.EntpCusId);
                    if (!isexit) {
                        this.customerList.push({
                            EntpCusId: salesOrderModel.EntpCusId,
                            EntpCusName: salesOrderModel.EntpCusName,
                            CallNum: salesOrderModel.PhoneNum,
                            FullAddress: salesOrderModel.FullAddress
                        });
                    }

                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == salesOrderModel.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: salesOrderModel.SId,
                            EmployeeName: salesOrderModel.SName
                        });
                    }
                    isexit = this.FollowerList.find(e => e.EmployeeId == salesOrderModel.FollowerId);
                    if (!isexit) {
                        this.FollowerList.push({
                            EmployeeId: salesOrderModel.FollowerId,
                            EmployeeName: salesOrderModel.FollowerName
                        });
                    }
                    if (this.isOrgShow && salesOrderModel.OrgId) {
                        this.oldOrgId = salesOrderModel.OrgId;
                        this.orgList.push({
                            Id: salesOrderModel.OrgId,
                            Name: salesOrderModel.OrgName
                        });
                    }
                }
                if (salesOrderModel && salesOrderModel.WarehouseId) {
                    let isexit = this.warehouseList.find(e => e.WarehouseId == salesOrderModel.WarehouseId);
                    if (!isexit)
                        this.warehouseList.push({
                            WarehouseId: salesOrderModel.WarehouseId,
                            WarehouseName: salesOrderModel.WarehouseName,
                            Type: salesOrderModel.WarehouseType
                        });
                } else {
                    this.getdefaultWarehouses();
                }

                if (datalist && datalist.length > 0) {
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < datalist.length; i++) {
                        _allNum += Number(datalist[i].Count);
                        _allMoney += datalist[i].Count * datalist[i].MarketPrice ? datalist[i].Count * datalist[i].MarketPrice : 0;
                        datalist[i].hasLock = this.hasLock;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = datalist;
                }
                resolve();
            });
        },
        //从缓存中读取上次开单的部门
        getLastOrderOrgId() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                if (this.orgList.length == 0) {
                    this.$util.getParentOrgs().then(data => {
                        this.orgList = data;
                        this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                            if (result) {
                                let orgdata = JSON.parse(result);
                                if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                    this.submitData.OrgId = orgdata.OrgId;
                                    this.submitData.OrgName = orgdata.OrgName;
                                }
                            }
                            resolve();
                        });
                    });
                } else
                    this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                        if (result) {
                            let orgdata = JSON.parse(result);
                            if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                this.submitData.OrgId = orgdata.OrgId;
                                this.submitData.OrgName = orgdata.OrgName;
                            }
                        }
                        resolve();
                    });
            });
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly || !this.isDefaultWH) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({ CacheKey: 'defaultOutWarehouses', CacheType: '1' }, true).then(result => {
                    if (result) {
                        let data = JSON.parse(result);
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        },
        //从缓存中获取跟进人
        getSalesOrderFollower() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({ CacheKey: 'salesOrder_follower' }, true).then(result => {
                    if (result) {
                        let data = JSON.parse(result);
                        let fo = this.FollowerList.filter(f => f.EmployeeId == data.FollowerId);
                        if (fo.length == 0) {
                            this.FollowerList.push({
                                EmployeeId: data.FollowerId,
                                EmployeeName: data.FollowerName
                            });
                        }
                        this.submitData.FollowerId = data.FollowerId;
                    }
                    resolve();
                });
            });
        },
        /**
         * 获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * FullAddress 收货地址
         */
        getDefaultData() {
            let that = this;
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: that.submitData.EntpCusId,
                        type: '0'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        let isexit = this.customerList.find(e => e.EntpCusId == that.submitData.EntpCusId);
                        if (!isexit) {
                            that.customerList.push({
                                EntpCusId: that.submitData.EntpCusId,
                                EntpCusName: that.submitData.EntpCusName,
                                CallNum: data.CusPhone,
                                FullAddress: data.FullAddress
                            });
                        }
                        that.submitData.FullAddress = data.FullAddress;

                        that.submitData.PayType = data.PayType;

                        if (that.submitData.PayType) {
                            let ml = that.payWayList.filter(f => f.Value === that.submitData.PayType);
                            if (ml.length > 0) {
                                that.isPaySpecial = ml[0].IsSpecial;
                            } else {
                                that.submitData.PayType = '';
                            }
                        }

                        //海口不要的
                        if (!that.isUnUseDFSend) {
                            that.submitData.ShipType = data.ShipType;
                            that.submitData.LogisticId = data.LogisticId;
                            that.submitData.LogisticName = data.LogisticName;
                            that.submitData.LogisticItem = data.LogisticName;
                            if (data.LogisticId) {
                                let logist = that.logisticsList.find(e => e.Id == data.LogisticId);
                                if (!logist) {
                                    that.logisticsList.push({
                                        Id: data.LogisticId,
                                        Name: data.LogisticName,
                                        Phone: ''
                                    });
                                }
                            }
                            if (that.saveCustomerCache) {
                                that.submitData.Remark = data.Remark;
                            }
                        }

                        that.ownMoney = data.OwnMoney;
                        that.maxCreditMoney = data.MaxCreditMoney;
                        that.creditDay = data.CreditDay;
                        that.creditType = data.CreditType;
                        that.isForbid = data.IsForbid;
                        if (data.IsForbid) {
                            //this.$util.errorMsg('该客户已被限制开单（已达限额或限期），请选择非挂账支付方式进行开单');
                            //改成更加直观的弹窗
                            that.warningVisible = true;
                        }
                        //海口要的
                        if (that.isBPriceShow) {
                            that.submitData.PhoneNum = data.CusPhone;
                            if (data.OrgId && data.OrgName && !that.isLastOrg) {
                                that.submitData.OrgId = data.OrgId;
                                that.submitData.OrgName = data.OrgName;
                                let bm = that.orgList.find(e => e.Id == data.OrgId);
                                if (!bm) {
                                    that.orgList.push({
                                        Id: data.OrgId,
                                        Name: data.OrgName
                                    });
                                }
                            }
                            if (data.Warehouse && data.Warehouse.WarehouseId) {
                                let w = that.warehouseList.find(e => e.WarehouseId == data.Warehouse.WarehouseId);
                                if (!w) {
                                    that.warehouseList = [
                                        {
                                            WarehouseId: data.Warehouse.WarehouseId,
                                            WarehouseName: data.Warehouse.WarehouseName,
                                            Address: data.Warehouse.Address,
                                            Type: data.Warehouse.WarehouseType
                                        }
                                    ];
                                }
                                if (!that.submitData.WarehouseId) {
                                    that.warehouseType = data.Warehouse.WarehouseType;
                                    that.$set(that.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                                    that.$set(that.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                                    that.$set(that.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                                }
                            }
                        }

                        //价格等级逻辑
                        that.priceType = data.PriceType;
                        that.pricePoint = data.PricePoint;
                        that.calcType = data.CalcType;
                    }
                });
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    this.cusForm.stopLoad = data && data.length < this.cusForm.Limit;
                    if (data) this.customerList = [...this.customerList, ...data];
                    //修改客户时要更新页面上展现的名称
                    if (this.customerList.length > 0) {
                        let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                        if (currCust) {
                            this.submitData.EntpCusName = currCust.EntpCusName;
                            this.submitData.PhoneNum = currCust.CallNum;
                            this.addressList = [];
                            //这里要处理多个地址问题
                            if (currCust.FullAddress) {
                                if (currCust.FullAddress.indexOf('{$}') != -1) {
                                    let addressArray = currCust.FullAddress.split('{$}');
                                    addressArray.forEach((e, i) => {
                                        this.addressList.push({
                                            value: e
                                        });
                                    });
                                    this.submitData.FullAddress = addressArray[0];
                                } else {
                                    this.submitData.FullAddress = currCust.FullAddress;
                                }
                            }
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 搜索物流
        searchLogistic(key) {
            if (![undefined].includes(key)) {
                this.logisForm.Page = 1;
                this.logisForm.stopLoad = false;
                this.logisForm.key = key;
                this.logisticsList = [];
            }
            if (this.logisForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchLogistic(this.logisForm.key, this.logisForm.Page, this.logisForm.Limit)
                .then(data => {
                    this.logisForm.stopLoad = data && data.length < this.logisForm.Limit;
                    if (this.logisForm.Page == 1) this.logisticsList = [];
                    if (data) this.logisticsList = [...this.logisticsList, ...data];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        searchLogisLoad() {
            this.logisForm.Page += 1;
            this.searchLogistic();
        },
        // 搜索汽配编码
        searchCode(key, item, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                //Id_old、APCode_old用来记录历史数据，用于恢复使用
                item.Id_old = item.EntpTempGoodsId;
                item.APCode_old = item.APCode;
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: true,
                        SFrom: 'apc'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        //汽配编码下拉框光标离开
        blurCode(event, item) {
            setTimeout(() => {
                //当商品明细列没有选择新的商品时，输入框的值恢复原来的
                if (item && item.EntpTempGoodsId && item.Id_old && item.EntpTempGoodsId == item.Id_old) item.APCode = item.APCode_old;
            }, 100);
        },
        //单元格编辑状态下被关闭时
        editClosed(data) {
            //当商品明细列没有选择新的商品时，输入框的值恢复原来的
            let item = data.row;
            if (item && item.EntpTempGoodsId && item.Id_old && item.EntpTempGoodsId == item.Id_old) item.APCode = item.APCode_old;
        },
        //结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        // 编码改变
        codeChange(value, index, option) {
            if (option) {
                option.onclick = function () {};
            }
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EntpTempGoodsId == value) {
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;

                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].LatestSalesTime = _list[i].LatestSalesTime;
                    this.dataList[index].LatestQuoteTime = _list[i].LatestQuoteTime;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].State = 0;
                    this.dataList[index].BillingPrice = _list[i].MarketPrice == 0 ? '' : _list[i].MarketPrice;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Brand = _list[i].Brand;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '0').then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                            this.dataList[index].LatestQuoteTime = data.LatestQuoteTime;

                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                            this.dataList[index].IntenCount = data.IntenCount;

                            if (this.IsNoZeroGoods && data.StorageInventory == 0) {
                                this.$util.warningMsg(`商品【${this.dataList[index].APCode}】当前库存商品为零`);
                            }
                        }
                    });
                    break;
                }
            }
            let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
            inputAll[0].focus();
            this.priceChange();
        },
        // 客户改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
                that.submitData.PhoneNum = '';
                that.addressList = [];
                that.submitData.FullAddress = '';
            } else {
                //获取客户的名称、手机号、地址等数据
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                    that.submitData.PhoneNum = currCust.CallNum;
                    that.addressList = [];
                    //这里要处理多个地址问题
                    if (currCust.FullAddress) {
                        if (currCust.FullAddress.indexOf('{$}') != -1) {
                            let addressArray = currCust.FullAddress.split('{$}');
                            addressArray.forEach((e, i) => {
                                that.addressList.push({
                                    value: e
                                });
                            });
                            that.submitData.FullAddress = addressArray[0];
                        } else {
                            that.submitData.FullAddress = currCust.FullAddress;
                        }
                    }
                }
                //查询对客户最新的商品销售价格
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsLatestPriceByCId',
                                data: {
                                    cId: value,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    // 此时，商品已经填写对应的销售价、开单价的时，再选中客户，商品的销售价、开单价不变 edit 2020/3/22
                                    if (e.MarketPrice == 0 || e.MarketPrice == '0' || !(e.MarketPrice == null || e.MarketPrice == '')) return;

                                    let getGoods = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getGoods) {
                                        // e.HidePrice=getGoods.MarketPrice;
                                        //替换销售价
                                        e.MarketPrice = getGoods.Price;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
                this.getDefaultData();
            }
        },
        //查地址列表
        querySearch(queryString, cb) {
            var restaurants = this.addressList;
            cb(restaurants);
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.SName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //跟单采购员的改变
        followerChange(value) {
            let _list = this.FollowerList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.FollowerName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length <= 1) that.searchLogistic();
            }
        },
        logisticChange(item) {
            if (!item) {
                this.submitData.LogisticName = '';
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
            } else if (typeof item == 'string') {
                this.submitData.LogisticName = item;
                this.submitData.LogisticId = '';
            } else {
                this.submitData.LogisticName = item.EntpCusName;
                this.submitData.LogisticId = item.EntpCusId;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                switch (code) {
                    case 'GoodName':
                        that.$refs[`sapcode`].focus();
                        break;
                    case 'AutoSerise':
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'Count':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`countRef`].focus();
                        break;
                    case 'MarketPrice':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'BillingPrice':
                        that.$refs[`marketPirceRef`].focus();
                        break;
                }
            } else if (ev.key == 'ArrowRight') {
                switch (code) {
                    case 'APCode':
                        if (that.$refs[`sapcode`]) that.$refs[`sapcode`].blur();
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'GoodName':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'AutoSerise':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`countRef`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Count':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`marketPirceRef`].focus();
                        break;
                    case 'MarketPrice':
                        if (that.$refs[`billingPriceRef`]) that.$refs[`billingPriceRef`].focus();
                        break;
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                that.$util.getParentOrgs().then(data => {
                    that.orgList = data;
                });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                that.$util.getSalesOrderSources().then(data => {
                    that.cusSourcesList = data;
                });
            }
        },
        sourceChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.cusSourcesList.length; i++) {
                    if (val == that.cusSourcesList[i].Value) {
                        that.submitData.CusSourcesName = that.cusSourcesList[i].Text;
                        break;
                    }
                }
            } else {
                that.submitData.CusSourcesName = '';
            }
        },
        getSetsData() {
            let that = this;
            that.columnShowSets = [];
            that.$util.getTBSetsForShow(that.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    that.columnShowSets.push(colums);
                    switch (item.ColumnCode) {
                        case 'APCode':
                            that.isExObj_APCode = true;
                            break;
                        case 'GoodName':
                            that.isExObj_GoodName = true;
                            break;
                        case 'AutoSerise':
                            that.isExObj_AutoSerise = true;
                            break;
                        case 'GoodCode':
                            that.isExObj_GoodCode = true;
                            break;
                        case 'Cate':
                            that.isExObj_Cate = true;
                            break;
                        case 'Brand':
                            that.isExObj_Brand = true;
                            break;
                        case 'Inventory':
                            that.isExObj_Inventory = true;
                            break;
                        case 'Size':
                            that.isExObj_Size = true;
                            break;
                        case 'Origin':
                            that.isExObj_Origin = true;
                            break;
                        case 'GoodDesc':
                            that.isExObj_GoodDesc = true;
                            break;
                    }
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 100) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        downKeyToLoad() {
            if (this.tableData && this.tableData.length > 0) {
                this.searchData.page += 1;
            } else {
                this.searchData.page = 1;
            }
            this.getAPTableData();
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }
            if (this.isBrandSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Brand';
                this.searchData.SortType = 'descending';
            } else if (this.isOriginSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Origin';
                this.searchData.SortType = 'descending';
            }

            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.WarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }

            if (this.autoSeriesModel) {
                if (this.isUseAS) {
                    if (this.autoSeriesModel.AutoSeriesId) this.searchData.AutoSeriseId = this.autoSeriesModel.AutoSeriesId;
                    else this.searchData.AutoSerise = this.autoSeriesModel.ModelName;
                } else this.searchData.AutoSeriseId = '';
            }

            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;
            let url = '';
            if (this.isUseSE) url = '/api/EntpGoods/GetGoodsListFromSE';
            else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }

                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadSpaceInvent = true;
                        //防止出现NaN在页面
                        data[i].OrderWaitOutQuantity = 0;
                        data[i].POrderWaitInQuantity = 0;
                    }

                    let list = [...this.tableData, ...data];
                    const maps = new Map();
                    list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));

                    //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;

                    let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
                    let poiqIsShow = this.isExObj('POrderWaitInQuantity');
                    let ppIsShow = this.isExObj('PlanPurchase');
                    let icIsShow = this.isExObj('IntenCount');
                    let rIsShow = this.isExObj('Remaining');

                    if (owoqIsShow || poiqIsShow || ppIsShow || icIsShow || rIsShow) {
                        this.getOtherData(data);
                    }
                })
                .catch(e => {})
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(100);
                }
                //使用表格方法更新数据，因为浏览器的兼容性，某些浏览器数据更新了但是页面线上还没有边，需要点击其它地方或滚动条滚动一下才触发变化，比如留余数一列
                if (this.$refs.multipleTable) this.$refs.multipleTable.updateData();
            }
        },
        loopGetData(id) {
            let that = this;
            let url = '';
            if (that.isUseSE) url = '/api/EntpGoods/GetAfteSearchPartForSE';
            else url = '/api/EntpGoods/GetAfteSearchPartData_V3';

            let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
            let poiqIsShow = this.isExObj('POrderWaitInQuantity');
            let ppIsShow = this.isExObj('PlanPurchase');
            let icIsShow = this.isExObj('IntenCount');
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        goodsId: id,
                        sId: that.searchData.SId,
                        isShowPlanPur: ppIsShow,
                        isShowOrderWaitOut: owoqIsShow,
                        isShowPOrderWaitIn: poiqIsShow,
                        isShowInven: icIsShow
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.IntenCount = data.IntenCount;
                            item.PlanPurchase = data.PlanPurchase;
                            item.SeriesCount = data.SeriesCount;
                            item.IsCommonSeries = data.IsCommonSeries;
                            if (that.isUseSE) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            if (!that.submitData.WarehouseId) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                AutoSeriseId: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            };
            this.isSearch = false;
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;

            if (!that.searchLoading) {
                that.getAPTableData();
                if (that.$refs.multipleTable) that.$refs.multipleTable.clearSort();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            if (that.menuVisible) that.menuVisible = false;
            that.dataindex = row.index;
            that.currentRow = row;
            that.getInvenDatas(row);
        },
        getInvenDatas(row) {
            let that = this;
            if (!row) return;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsStorageInvens',
                    data: {
                        GoodsId: row.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.isShowSummary = true;
                    that.summaryList = data;
                })
                .catch(() => {});
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            if (that.menuVisible) that.menuVisible = false;
            //先获取一些数据
            if ([e][0]) {
                that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                that.$util.getGoodsDataForConfirm_V3(e.EntpTempGoodsId, '', that.submitData.EntpCusId, '0', that.IsMPrice, e.MarketPrice).then(data => {
                    if (data) {
                        that.rowForm = {
                            ...[e][0],
                            _price: data.LatestPrice,
                            _biilPrice: data.LatestPrice,
                            _count: 1,
                            _referencePrice:
                                that.profitRate != 0 ? (e.CostPrice * (1 + that.profitRate / 100)).toFixed(2) : data.ReferencePrice ? data.ReferencePrice : e.MarketPrice
                        };
                        if (that.refPriceToPrice) that.rowForm._price = that.rowForm._referencePrice;
                    }
                    //默认选中数量
                    that.selectAutoHandle('confirm_0');
                    that.rowFormLoading = false;
                });
            }
        },
        priceCheck(row) {
            let that = this;
            if (row.EntpTempGoodsId) {
                that.$util
                    .getEnterprisePart(row.EntpTempGoodsId)
                    .then(data => {
                        if (data) {
                            let price = data.MarketPrice;
                            let checkval = Number(price) * ((100 - that.LoseMoneyValue) / 100) > Number(row.MarketPrice);

                            let ischeck = false;
                            if (checkval) {
                                this.$util.warningMsg('当前销售价格已经低于所设置的最低价格，请确认！');
                                ischeck = true;
                            }
                            if (this.isCheckPriceCS && !ischeck) {
                                let price2 = row.MarketPrice;
                                let checkval2 = Number(price2) < row.CostPrice;
                                if (checkval2) {
                                    this.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                                }
                            }
                        }
                    })
                    .catch(() => {});
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            let checkval = Number(item.MarketPrice) * ((100 - that.LoseMoneyValue) / 100) > Number(item._price);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                that.dataList[fIdx].Count = item._count;
                that.dataList[fIdx].MarketPrice = item._price;
                that.dataList[fIdx].BillingPrice = item._biilPrice;
                if (this.isCheckPriceCS) {
                    let checkval2 = Number(item._price) < item.CostPrice;
                    if (checkval2) {
                        this.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                    }
                }
            } else {
                let newGoods = {};
                newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    Count: item._count,
                    MarketPrice: item._price,
                    Unit: item.Unit,
                    Remark: '',
                    CodeRepeat: false,
                    Inventory: item.Inventory,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    LatestSalesTime: item.LatestSalesTime,
                    LatestQuoteTime: item.LatestQuoteTime,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item.CostPrice,
                    BillingPrice: item._biilPrice,
                    Origin: item.Origin,
                    Size: item.Size,
                    Brand: item.Brand,
                    IsUrgent: false
                };
                if (that.IsNoZeroGoods && item.StorageInventory == 0) {
                    if (!checkval) that.$util.warningMsg(`商品【${item.APCode}】当前库存商品为零`);
                    else if (this.isCheckPriceCS) {
                        let checkval2 = Number(item._price) < item.CostPrice;
                        if (checkval2) this.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                    } else that.$util.warningMsg(`商品【${item.APCode}】当前库存商品为零；且当前销售价格已经低于所设置的最低价格，请确认！`);
                } else {
                    if (checkval) {
                        that.$util.warningMsg('当前销售价格已经低于所设置的最低价格，请确认！');
                    } else if (this.isCheckPriceCS) {
                        let checkval2 = Number(item._price) < item.CostPrice;
                        if (checkval2) {
                            this.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                        }
                    }
                }
                that.dataList.push(newGoods);
            }
            that.addPageChace();
            that.priceChange();
            that.rowVisible = false;
            that.isStartConfirm = false;
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showPurPlanData(item) {
            if (item.EntpTempGoodsId && !this.purPlanDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.purPlanTitle = '【采购单据明细】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.purPlanDataVisible = true;
            } else if (item.EntpTempGoodsId && this.purPlanDataVisible) {
                this.$refs.APPurPlanDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        goback() {
            this.$router.push('/salesManage/salesOrder');
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        chooseAllAPsHandle() {
            let that = this;
            that.$confirm('是否将查询结果全部加入到订单商品明细中？', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        _totalCount: this.tableDataLength
                    };
                    //当查询结果出来后，用过有可能加载下一页数据，所以全部加入订单时要重置页码
                    this.searchApParams.page = 1;
                    this.loopSearch();
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            let url = '';
            if (this.isUseSE) url = '/api/EntpGoods/GetGoodsListFromSE';
            else url = '/api/EntpGoods/GetGoodsListForEditOrder_V3';
            const { data } = await this.$util.axiosPost({
                url: url,
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);

            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.addToList(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        addToList(items) {
            let that = this;
            let itemList = [...items];
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.EntpTempGoodsId == e.EntpTempGoodsId) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: this.initNumber,
                        MarketPrice: item.MarketPrice,
                        Unit: item.Unit,
                        Origin: item.Origin,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        LatestSalesTime: item.LatestSalesTime,
                        LatestQuoteTime: item.LatestQuoteTime,
                        State: 0,
                        canEdit: true,
                        IntenCount: item.IntenCount,
                        CostPrice: item.CostPrice,
                        BillingPrice: item.MarketPrice == 0 ? '' : item.MarketPrice,
                        Size: item.Size,
                        Brand: item.Brand,
                        IsUrgent: false
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.MarketPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            that.addPageChace();
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            if (cb) {
                this.apCodeCallBack = cb;
            }
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (this.apCodeCallBack) {
                    this.apCodeCallBack(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (cb) {
                this.nameCallBack = cb;
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (this.nameCallBack) {
                    this.nameCallBack(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (cb) {
                this.autoCallBack = cb;
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (this.autoCallBack) {
                    this.autoCallBack(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            if (cb) {
                this.originCallBack = cb;
            }
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (this.originCallBack) {
                    this.originCallBack(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
            this.$message.closeAll();
        },
        async getGoodsImages() {
            if (this.currentRow) {
                if (!this.srcList || this.srcList.length == 0) {
                    const { data } = await this.$util.axiosGet({
                        url: '/api/EntpGoods/GetGoodsImages',
                        data: { goodsId: this.currentRow.EntpTempGoodsId }
                    });
                    if (data) {
                        this.srcList = data;
                    }
                }
                this.showViewer = true;
                this.$message({
                    message: this.currentRow.APCode,
                    center: true,
                    duration: 0,
                    customClass: 'apcode_msgCls'
                });
            }
        },
        closeAutoSeries() {
            this.autoSeriesModel = null;
            this.searchData.AutoSeriseId = '';
        },
        refreshResult() {
            this.searchData.page = 1;
            this.handleSearch();
        },
        showOwnDialog() {
            this.isShowOwn = true;
        },
        closeOwnDetails() {
            this.isShowOwn = false;
        },
        payChange(value) {
            let _list = this.payWayList;
            let ml = _list.filter(f => f.Value === value);
            if (ml.length > 0) {
                this.isPaySpecial = ml[0].IsSpecial;

                if (this.isPaySpecial && this.isForbid) {
                    this.warningVisible = true;
                }
            }
        },
        vinSearch() {
            this.vinSearchVisible = true;
        },
        closeVinSearch() {
            let that = this;
            that.vinSearchVisible = false;
            that.autoSeriesModel = this.$util.getLocalStorage('vin_createParams');
            if (that.autoSeriesModel) {
                that.isUseAS = true;
                that.$util.clearLocalStorage('vin_createParams');
                that.handleSearch();
            }
        },
        showSeries(item) {
            if (item && item.EntpTempGoodsId) {
                this.goodsId = item.EntpTempGoodsId;
                this.seriesVisible = true;
            } else {
                this.goodsId = '';
                this.seriesVisible = false;
            }
        },
        updateDataList(val) {
            if (val == 1) {
                let datalist = this.$util.getLocalStorage('salesOrder_dataList');
                if (datalist && datalist.length > 0) {
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < datalist.length; i++) {
                        _allNum += Number(datalist[i].Count);
                        _allMoney += datalist[i].Count * datalist[i].MarketPrice ? datalist[i].Count * datalist[i].MarketPrice : 0;
                        datalist[i].hasLock = this.hasLock;
                    }
                    this.allMoney += _allMoney;
                    this.allNum += _allNum;
                }

                this.dataList = [...this.dataList, ...datalist];
                this.$util.setLocalStorage('salesOrder_dataList', this.dataList);
            }
        },
        //商品搜索结果了表格点击鼠标右键触发
        handleRowContextmenu(row, column, event) {
            if (!this.permission.addTOPurOder) return;

            if (this.menuVisible == true) return;
            if (!(this.currentRow && this.currentRow.EntpTempGoodsId)) return;
            if (this.currentRow.EntpTempGoodsId != row.EntpTempGoodsId) return;
            this.menuVisible = false;
            this.menuVisible = true;
            // 阻止右键默认行为
            event.preventDefault();
            this.$nextTick(() => {
                this.$refs.contextbutton.init(row, column, event);
            });
        },
        menuListen() {
            // 取消鼠标监听事件 菜单栏
            this.menuVisible = false;
            document.removeEventListener('click', this.menuListen);
        },
        //快速选择菜单
        handleMenu(item) {
            //返回 {item:item,row:this.row};
            this.currentRow.Remaining =
                this.currentRow.StorageInventory + (this.isAddWaitIn ? this.currentRow.POrderWaitInQuantity : 0) - this.currentRow.OrderWaitOutQuantity;
            this.aToPurOrderVisible = true;
        },
        //关闭添加到采购单弹窗
        closeAddToPurOrder() {
            this.aToPurOrderVisible = false;
        },
        //关闭弹窗前
        aToPurOrderBeforeClose(done) {
            this.$refs.addGoodsToPurOrder.beforeColse();
        },
        urgentchange(row) {
            let that = this;
            //IsUrgent会是false是因为去掉勾选后已经改变了值
            if (!row.IsUrgent && row.WarehousedCount > 0) {
                that.dataList.forEach(e => {
                    if (row.EntpTempGoodsId == e.EntpTempGoodsId) {
                        e.WarehousedCount = 0;
                        e.IsDelivery = false;
                    }
                });
            } else if (row.IsUrgent && that.type == 8) {
                that.dataList.forEach(e => {
                    if (row.EntpTempGoodsId == e.EntpTempGoodsId) {
                        e.WarehousedCount = e.Count;
                        e.IsDelivery = true;
                    }
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .el-autocomplete-suggestion {
    max-width: 300px; /* 限制下拉框最大宽度 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* 超出部分显示省略号 */
}
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}
.saleorder-v3 {
    padding: 10px 20px 0px 20px;
}

.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
    position: relative;
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .color-red {
        margin-right: 4px;
    }

    .sort-view {
        display: flex;
        flex-direction: column;

        i {
            line-height: 8px;
            cursor: pointer;
        }

        .active {
            color: #409eff;
        }
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}

.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}

.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}

.discount-zone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-input-number {
        width: 110px;

        .el-input__inner {
            height: 32px;
        }
    }

    .el-select {
        margin-right: 12px;

        .el-input__inner {
            width: 110px;
            height: 32px;
            color: red;
        }

        .el-input__suffix {
            top: 4px;
        }

        .is-focus {
            .el-input__suffix {
                top: -4px;
            }
        }
    }
}

#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#ap-image-dialog {
    position: absolute;
    top: auto;
    left: 0;
    right: auto;
    bottom: 400px;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}

#vin-search-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
    margin-left: 2px;
}

.btn-own {
    color: red;
    padding: 0 !important;
    font-size: 16px;
}
.wNameTip {
    display: inline-block;
    position: absolute;
    right: 90px;
    top: 0px;

    i {
        font-weight: 500;
    }
}
</style>

<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}

.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;

    .popper__arrow {
        color: #303133;
    }
}

#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        overflow: auto;
    }
}

#search-dialog::-webkit-scrollbar {
    display: none;
}

.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.el-row {
    margin-bottom: 10px !important;

    &:last-child {
        margin-bottom: 10px !important;
    }
}

.search-in-order {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}

.sales-order-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }

        // .elx-table--body tr.row--current > td {
        //   background: rgb(206, 206, 206) !important;
        // }
    }

    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}
.apcode_msgCls {
    position: absolute;
    top: auto !important;
    bottom: 130px;
    height: 30px;

    .el-message__icon {
        display: none;
    }

    .el-message__content {
        font-size: 24px;
    }
}
.dialog-content {
    .el-icon-info {
        color: rgb(250, 148, 15);
        font-size: 20px;
        vertical-align: top;
        cursor: pointer;
        margin-top: 10px;
        margin-left: 4px;
    }
}
</style>
